import { Component, OnInit, Injectable } from "@angular/core";
declare let jsPDF;
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
  FormArray,
} from "@angular/forms";
import {
  NgbCalendar,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { RestService } from "../../master-services/Rest/rest.service";
import { ForkliftService } from "../../master-services/Forklift/forklift.service";
import { UploadService } from "../../master-services/services/upload.service";
import { UserService } from "../../master-services/User/user.service";
import { EstimateService } from "../../master-services/estimate/estimate.service";
//import * as jsPDF from 'jspdf';
import "jspdf-autotable";
import { UserOptions } from "jspdf-autotable";

/*interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}*/

import { NgbProgressbarModule } from "@ng-bootstrap/ng-bootstrap";

import swal from "sweetalert2";
import { Router } from "@angular/router";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { DomEventsPlugin } from "@angular/platform-browser/src/dom/events/dom_events";
import { async } from "@angular/core/testing";
import TrmApi from "trm-api";
import { float } from "aws-sdk/clients/lightsail";
import { OrderService } from "../../master-services/order-service/orderservice.service";

const trmapi = new TrmApi();

const I18N_VALUES = {
  fr: {
    weekdays: ["Lun", "Mar", "Mié", "Juv", "Vie", "Sáb", "Dom"],
    months: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Agos",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
  },
  // other languages you would support
};

interface emailFormat {
  // item para mostrar selccionados
  email?: string;
  contact?: string;
}

interface itemSelectInterface {
  // item para mostrar selccionados
  id?: number;
  item?: string;
  description?: string;
  cost?: number;
  quantity?: number;
  active?: boolean;
  type?: boolean;
}

interface fileImage {
  // item para mostrar selccionados
  content?: any;
  ext?: string;
  url?: string;
}

@Injectable()
export class I18n {
  language = "fr";
}

@Component({
  selector: "app-master-OS-all",
  templateUrl: "./master-OS-all.component.html",
  styleUrls: [
    "./master-OS-all.component.scss",
    "../../../assets/icon/icofont/css/icofont.scss",
  ],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: MasterEstimateOSComponent },
  ],
})
export class MasterEstimateOSComponent extends NgbDatepickerI18n {
  public userModel = {
    id: 0,
    name: "",
    roles: [],
  };

  public filterCriteria = {
    orderServiceConsecutiveF: "",
    selectedBusinessId: "",
    startDate: "",
    endDate: "",
    orderStatus: "",
    selectedUserId: "",
  };

  names = ["", "Juan", "Pedro"];
  modelPopup: any;
  modelPorpup: any;

  emailsSend: Array<emailFormat> = [];
  emailSend: emailFormat;

  filesImage: Array<fileImage> = [];
  fileImage: fileImage;

  myForm: FormGroup;
  myFormUpdate: FormGroup;
  submitted = false;
  rowsClient: any;
  rowsTemp: any;
  rowStatic: any;
  rows: any;
  a: any = 5;
  kilo: any;
  elementDelete: any;
  indice: number = 0;
  comment: "";
  images: Array<any> = [];
  switchCreate = true;
  switchUpdate = true;
  change = true;
  active = false;
  inactive = false;
  enabledUpdated = false;

  filterIndicatorText = false;
  filterIndicatorCheck = false;

  checkHideCode = false; // false por defecto
  filesEstimateImage: any;

  extImageOne: string;
  extImageTwo: string;
  extImageThree: string;
  extImageFour: string;

  rowsTempCheck: any;
  rowsTempText: any;

  currentBrand: any;

  customers: any = [];
  forklifts: any;
  branchOffices: any;

  orderservices: any;
  progressBar_value: number;
  orderservicesFilters: any;
  users_comercials: any;

  part: any = "";
  codepart: any = "";

  numberEstimate: any = "";

  subject: any = "";
  message: any;
  emails: any;
  quantityItem: any;

  checkAllWorkForce = false;
  checkAllPart = false;
  considerDate = true;
  imgBase: string = "";

  listStatus: any = [];

  selectedBusinessId: any = 0;
  selectedForkliftId: any = 0;
  selectedBranchOfficeId: any = 0;
  selectedOfficeId: any = 0;
  selectedUserId: any = 0;
  customerOffices: any = 0;
  rowsUser: any;
  rowsItemsparts: any;
  rowsItemsWorkforce: any;
  estimateId: any;
  blobGlobal: any;
  iva: any;
  total_iva: any;

  forkliftText: any = "";
  cityEstimate: any = "";
  guarantyEstimate: any = "";
  validity: any = "";
  payment_method: any = "";
  subtotalHoursEstimate: any = "";
  subtotalPartsEstimate: any = "";
  totalEstimate: any = "";
  ivaC: any = "";
  tolIva: any = "";
  observationEstimate: any = "";

  user: any;
  consecutive: any;
  documentCustomer: any;
  creationDate: any;
  nameCustomer: any;
  contact: any;
  cellphone: any;

  estimateCurrent: any;

  s3info: any;
  detailform: FormGroup;

  masterEmail: any = "";
  masterName: any = "";

  rowsItemsWorkforceApproval: any;
  rowsItemsPartsApproval: any;

  itemsWorkforce: Array<itemSelectInterface> = [];
  itemWorkforce: itemSelectInterface;

  itemsPart: Array<itemSelectInterface> = [];
  itemPart: itemSelectInterface;

  itemsFinalApproval: Array<itemSelectInterface> = [];

  rejectionsEstimate: any;
  imageGlobal: any;

  columns = [{ name: "Estado", prop: "status" }];

  columnWidths = [{ column: "status", width: 200 }];

  partUpdateTemp: any;

  fromDate: NgbDateStruct;
  untilDate: NgbDateStruct;
  today = this.calendar.getToday();
  masterSelected: boolean;
  checklist: any;

  emailCustomer: any = "";
  emailShow: any = "";
  userCustomer: boolean = false;
  user_id: any;
  
  checkPendingProductMessages: { [key: number]: boolean } = {};
  
  checkPendingProductFilter: { [key: number]: boolean } = {};
  
  checkStockProductMessages: { [key: number]: boolean } = {};
  checkStockProductFilter: { [key: number]: boolean } = {};
  
  userAdvisor: boolean = false;
  ///Variables definidas

  orderServiceConsecutiveF: string = "";

  constructor(
    private restService: RestService,
    private _i18n: I18n,
    private router: Router,
    private estimateService: EstimateService,
    private forkliftService: ForkliftService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private userService: UserService,
    private uploadService: UploadService,
    private formbuilder: FormBuilder,
    private orderservice: OrderService
  ) {
    super();

    // this.getByState();
    // const subject = new FormControl("", Validators.required);
    // //const work = new FormControl('');
    // const comment = new FormControl("");
    // this.detailform = this.formbuilder.group({
    //   subject: subject,
    //   emails: this.formbuilder.array([
    //     this.formbuilder.group({
    //       email: [""],
    //     }),
    //     this.formbuilder.group({
    //       name: [""],
    //     }),
    //   ]),
    //   comment: comment,
    // });

    // var date = new Date();
    // var ngbDateStruct = {
    //   day: date.getDate(),
    //   month: date.getMonth() + 1,
    //   year: date.getFullYear(),
    // };

    // this.fromDate = ngbDateStruct;
    // this.untilDate = ngbDateStruct;

    // console.log(this.fromDate);
    // console.log(this.untilDate);

    // this.masterSelected = false;
    // this.checklist = [
    //   { id: 2, value: "APROBADO", isSelected: false },
    //   { id: 1, value: "ENVIADO", isSelected: false },
    //   { id: 0, value: "GENERADO", isSelected: false },
    //   { id: 5, value: "RECHAZADO", isSelected: false },
    // ];

    // const description = new FormControl("", Validators.required);
    // const descriptionUpdate = new FormControl("", Validators.required);

    // this.myForm = new FormGroup({
    //   description: description,
    // });

    // this.myFormUpdate = new FormGroup({
    //   descriptionUpdate: descriptionUpdate,
    // });
    if (
      Number(localStorage.getItem("profile")) == 10
    ) {
      this.user_id = Number(localStorage.getItem("userid"));
      this.getCustomerUser(this.user_id);
      this.userCustomer = true;
    } else if (
      Number(localStorage.getItem("profile")) == 2 ||
      Number(localStorage.getItem("profile")) == 3
    ) {
      this.userAdvisor = true;
      this.user_id = Number(localStorage.getItem("userid"));
      this.getCustomerForAdvisor(this.user_id);
    } else {
      // this.getUser();
      // this.loadingData();
      // this.getCustomers();
      this.getCustomers();
      this.getComercials();
      this.getOrderservice();
    }
  }

  //Comienza Funciones de produccion JMV
  go_createOS() {
    this.router.navigateByUrl("erp/customerorder");
  }
  getOrderservice() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getOrderservice()
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.orderservices = resp.data;
        console.log("Data recibida de ordenes:", this.orderservices);
        // Inicializa el estado de los productos pendientes para cada orden
        this.checkPendingProductMessages = {};
        (this.checkStockProductMessages = {}),
          this.orderservices.forEach((orderService: any) => {
            let hasPendingProducts = false;
            orderService.orders.forEach((order: any) => {
              if (order.import_order_details) {
                hasPendingProducts = order.import_order_details.some(
                  (detail: any) =>
                    detail.product_arrived === 1 &&
                    detail.product_dispatch === 0
                );
              }
            });

            // Almacena el resultado en la propiedad para usar en el HTML
            this.checkPendingProductMessages[
              orderService.orderservice_consecutive
            ] = hasPendingProducts;

            // Imprimir el resultado en consola
            console.log(
              `Condición cumplida para orderservice_consecutive ${orderService.orderservice_consecutive}:`,
              hasPendingProducts
            );
          });

        ////Aca validacion de productos en stock
        this.orderservices.forEach((orderService: any) => {
          let hasstockProducts = false;
          orderService.orders.forEach((order: any) => {
            if (order.import_order_details) {
              hasstockProducts = order.import_order_details.some(
                (detail: any) =>
                  detail.stock === 1 && detail.product_dispatch === 0
              );
            }
          });

          // Almacena el resultado en la propiedad para usar en el HTML
          this.checkStockProductMessages[
            orderService.orderservice_consecutive
          ] = hasstockProducts;

          // Imprimir el resultado en consola
          console.log(
            `Condición cumplida para orderservice_consecutive con sTOCKKKK ${orderService.orderservice_consecutive}:`,
            hasstockProducts
          );
        });

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  NextOrderserviceDetail() {
    // this.router.navigateByUrl("erp/customerorder");
    // this.router.navigateByUrl(`serviceorderdetail/${this.id}`);
  }

  //Termina Funciones de produccion JMV

  getCustomerUser(id: any) {
    this.userService
      .getUserCustomer(id)
      .then((data) => {
        const resp: any = data;
        this.customers = resp.data;
        this.filterCriteria.selectedBusinessId = this.customers[0].id;

        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 8);
        
        this.filterCriteria.startDate = startDate.toISOString().split('T')[0];
        this.filterCriteria.endDate = endDate.toISOString().split('T')[0];
        this.applyFilters();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  
  getCustomerForAdvisor(id: any) {
    this.restService
      .getCustomersForAdvisor(id)
      .subscribe(
        data => {
          const resp: any = data;
          this.customers = resp.data;

          const endDate = new Date();
          const startDate = new Date();
          // startDate.setDate(startDate.getDate() - 8);
          
          this.filterCriteria.startDate = startDate.toISOString().split('T')[0];
          this.filterCriteria.endDate = endDate.toISOString().split('T')[0];
          this.applyFilters();
        },
        error => {
          console.log(error);
        }
      );
  }

  getByState() {
    this.userService
      .getByState()
      .then((data) => {
        const resp: any = data;
        this.imgBase = resp.data;
        // console.log(this.customers)
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getBranchOfficeUser(id: any) {
    this.userService
      .getBranchUser(id, this.user_id)
      .then((data) => {
        const resp: any = data;
        this.branchOffices = resp.data;
        // console.log(this.customers)
      })
      .catch((error) => {
        console.log(error);
      });
  }

  loadingData() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.getEstimateFiltersInitial();
    /* this.forkliftService.getForklifts().then(data => {
      const resp: any = data;
      console.log(data);
      swal.close();
      this.rowsClient = resp.data;
      this.rowStatic =  resp.data;
      this.rowsTemp = resp.data;
      console.log( this.rowsClient);
    }).catch(error => {
      console.log(error);
    });*/
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  changeConsiderDate(event: any) {
    if (this.considerDate == true) {
      this.considerDate = false;
    } else {
      this.considerDate = true;
    }

    console.log("------");
    console.log(this.considerDate);
  }

  getIva(id: number) {
    this.estimateService
      .getIvaEstimate(id)
      .then((data) => {
        const item: any = data;

        swal.close();
        // let res:any = resp.data;

        console.log("valor iva");
        console.log(
          "----------------------valor iva---------------------------"
        );
        console.log(item);
        this.iva = this.finalFormat(item.iva);
        this.total_iva = this.finalFormat(item.tolIVa);

        console.log(
          "----------------------valor iva---------------------------"
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }

  downloadPdf(item: any, ind: number) {
    swal.showLoading();

    console.log("item :" + JSON.stringify(item));
    this.estimateId = item.id;
    this.getIva(this.estimateId);

    this.user = item.elaborate_user.username;
    this.consecutive = item.estimate_consecutive;
    this.documentCustomer = item.customer_document;
    this.nameCustomer = item.customer.business_name;
    this.contact = item.contact;
    this.cellphone = item.telephone;
    this.creationDate = item.create_at_date;
    console.log(this.forkliftText);
    console.log(item.forklift_text);
    if (item.forklift_text) {
      console.log("entro if");
      this.forkliftText = item.forklift_text;
      console.log(this.forkliftText);
    } else {
      console.log("entro else");
      this.forkliftText = "";
    }

    this.cityEstimate = item.city.name;
    this.guarantyEstimate = item.guaranty;
    this.validity = item.validity;
    this.payment_method = item.payment_method;
    this.subtotalHoursEstimate = item.subtotal_hours_decimal;
    this.subtotalPartsEstimate = item.subtotal_parts_decimal;
    this.totalEstimate = item.total_decimal;
    let toliva: float = Number(item.total_decimal) * 0.19;
    this.tolIva = (Number(item.total_decimal) + Number(toliva)).toFixed(3);
    let caliva = toliva.toFixed(3);
    this.ivaC = caliva;
    // ivaC :any = '' ;
    // tolIva:any = '';

    // console.log( "valor del iVA" +  item.iva);
    // console.log( "valor del TOTAL IVA "+item.total_iva);

    console.log(this.observationEstimate);
    console.log(item.observation);
    if (item.observation) {
      console.log("entro if");
      this.observationEstimate = item.observation;
      console.log(this.observationEstimate);
    } else {
      console.log("entro else");
      this.observationEstimate = "Observación";
    }

    // 0 Solo para descargar y 1 para enviar;

    // this.pp( this.estimateId);
    console.log("download ole");
    this.getEstimateParts(ind);
  }

  getEstimateParts(ind: number) {
    console.log("entro parts");
    if (this.estimateId) {
      this.estimateService
        .getEstimateDetailsParts(this.estimateId)
        .then((data) => {
          console.log("información repuestos: " + data);
          const resp: any = data;
          this.rowsItemsparts = resp.data;

          this.getEstimateWorkforce(ind);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  getEstimateWorkforce(ind: number) {
    console.log("Ingreso a la mano de obra");
    if (this.estimateId) {
      this.estimateService
        .getEstimateDetailsWorkforce(this.estimateId)
        .then((data) => {
          const resp: any = data;
          console.log("Ingreso a la mano de obra: " + resp.data);
          this.rowsItemsWorkforce = resp.data;
          // this.download3(ind);
          this.getFilesImage(ind); //Se omite carga de imagenes
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  // Estos consumos es para la vista de aprobación

  getEstimatePartsApproval(ind: number) {
    if (ind) {
      this.estimateService
        .getEstimateDetailsParts(ind)
        .then((data) => {
          const resp: any = data;
          this.rowsItemsPartsApproval = resp.data;

          console.log("información de items");
          console.log(this.rowsItemsPartsApproval);

          this.itemsPart = [];
          this.itemsWorkforce = [];
          this.rowsItemsPartsApproval.forEach((item) => {
            console.log(item);
            let unitPrice = Number(item.price) / Number(item.quantity);
            this.itemPart = {
              id: item.id,
              item: item.item,
              description: item.description,
              cost: unitPrice,
              quantity: item.quantity,
              active: false,
            };
            this.itemsPart.push(this.itemPart);
          });

          this.getEstimateWorkforceApproval(ind);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  getEstimateWorkforceApproval(ind: number) {
    if (ind) {
      this.estimateService
        .getEstimateDetailsWorkforce(ind)
        .then((data) => {
          const resp: any = data;
          this.rowsItemsWorkforceApproval = resp.data;
          swal.close();
          console.log(this.rowsItemsWorkforceApproval);
          this.rowsItemsWorkforceApproval.forEach((item) => {
            let unitPrice = Number(item.price) / Number(item.quantity);
            this.itemWorkforce = {
              id: item.id,
              item: item.item,
              description: item.service,
              cost: unitPrice,
              quantity: item.quantity,
              active: false,
            };
            this.itemsWorkforce.push(this.itemWorkforce);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  sendEmail() {
    console.log("entro sendEmail");

    // Si el estatus es

    let ind = 1; // 0 Solo para descargar y 1 para enviar;
    this.getEstimateParts(ind);
  }

  sendEmailEstimateAmazon() {
    console.log("IMPORTANTE INGRESO");
    let nameFileEstimate =
      "Cotizacion_No_" + this.estimateCurrent.estimate_consecutive + ".pdf";
    console.log(this.estimateCurrent.id + "," + 3 + " ," + nameFileEstimate);
    this.uploadService
      .uploadFilesAllEstimate(
        this.blobGlobal,
        this.estimateCurrent.id,
        3,
        nameFileEstimate
      )
      .then((res) => {
        console.log("s3info" + JSON.stringify(res));
        this.s3info = res;
        console.log(this.s3info);
        console.log("Cargo la info en s3 6/3/20");
        //Aqui va el codigo para enviar correo
        this.sendEmailFinal();

        /*swal({
      title: 'cotización almacenada',
      type: 'success'
     });*/

        //this.insertNew();
      })
      .catch((error) => {
        console.log(error);
        swal({
          type: "error",
          title: "oops a currido un error",
          text: "se ha presentado un error al subir la imagen",
          allowOutsideClick: false,
        });
      });
  }

  selectEvent(item) {
    console.log("este es el item: " + JSON.stringify(item));
    this.masterName = item.email;
    // masterName
    // do something with selected item
  }

  onChangeSearch(search: string) {
    console.log("search:" + JSON.stringify(search));
  }

  onFocused(e) {
    console.log("este es el e:" + +JSON.stringify(e));
  }

  upload() {
    this.uploadService
      .uploadFileForkliftUpdate3(this.blobGlobal)
      .then((res) => {
        console.log("que paso");
        console.log(this.blobGlobal);
        console.log("s3info" + JSON.stringify(res));
        this.s3info = res;
        console.log(this.s3info);
        //this.insertNew();
      })
      .catch((error) => {
        console.log(error);
        swal({
          type: "error",
          title: "oops a currido un error",
          text: error,
          allowOutsideClick: false,
        });
      });
  }

  sendEstimateEmail(row: any) {
    /*   this.estimateId= row.id;
      this.user = row.elaborate_user.username;
      this.consecutive = row.estimate_consecutive;
      this.documentCustomer = row.customer_document;
      this.nameCustomer = row.business_name;
      this.contact = row.contact;
      this.cellphone =   row.email;*/

    this.estimateId = row.id;
    this.user = row.elaborate_user.username;
    this.consecutive = row.estimate_consecutive;
    this.documentCustomer = row.customer_document;
    this.nameCustomer = row.customer.business_name;
    this.contact = row.contact;
    this.cellphone = row.telephone;
    this.creationDate = row.create_at_date;

    if (row.forklift_text) {
      console.log("entro if");
      this.forkliftText = row.forklift_text;
      console.log(this.forkliftText);
    } else {
      console.log("entro else");
      this.forkliftText = "";
    }
    this.cityEstimate = row.city.name;
    this.guarantyEstimate = row.guaranty;
    this.validity = row.validity;
    this.payment_method = row.payment_method;
    this.subtotalHoursEstimate = row.subtotal_hours_decimal;
    this.subtotalPartsEstimate = row.subtotal_parts_decimal;
    this.totalEstimate = row.total_decimal;
    this.observationEstimate = row.observation;
    let caliva = this.finalFormat(
      (Number(row.total_decimal) * (19 / 100)).toFixed(2)
    );
    this.ivaC = caliva;
    let tolIa = Number(row.total_decimal) + caliva;
    this.tolIva = this.finalFormat(Number(tolIa).toFixed(2));
    this.emailsSend = [];
    this.subject = "";
    this.comment = "";
    console.log("cotización actual:" + row);
    this.estimateCurrent = row;
    document.getElementById("showItemsApprove").click();
    this.getEmailCustomer();
  }

  finalFormat(num) {
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? "," + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + "." + "$2");
      console.log(splitLeft);
    }
    console.log("Importante oleole");
    console.log(splitLeft + splitRight);
    return splitLeft + splitRight;
  }

  getEmailCustomer() {
    //this.estimateCurrent.customer_id
    this.estimateService
      .getEmailsCustomer(this.estimateCurrent.customer_id)
      .then((data) => {
        const resp: any = data;
        console.log("que paso");
        this.emailCustomer = resp.data;
        //Poner un for para los email's
        console.log(this.emailCustomer);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showCheckItems(row: any) {
    let rowCurrent = row;
    this.estimateCurrent = row;
    this.getEstimatePartsApproval(rowCurrent.id);
    this.checkAllPart = false;
    this.checkAllWorkForce = false;
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    // this.getEstimateWorkforceApproval(rowCurrent.id);
    //this.checkItemsApprove(rowCurrent);
    document.getElementById("showCheckItem").click();

    swal.close();
  }

  checkItemsApprove(row: any) {
    let rowCurrent = row;
  }

  rejectionEstimate(row: any) {
    this.estimateCurrent = row;
    let rowCurrent = row;
    this.estimateService
      .getRejectionsEstimate()
      .then((data) => {
        const resp: any = data;
        console.log("info de filter");
        console.log(data);
        swal.close();
        // this.customers  = resp.data;
        this.rejectionsEstimate = resp.data;
        // this.rowStatic =  resp.data;
        // this.rowsTemp = resp.data;
        // console.log( this.rowsClient);
      })
      .catch((error) => {
        console.log(error);
      });
    document.getElementById("showRejection").click();
  }

  sendEmailEstimate() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    // Validar forma de envio de correo--
    // armar json de correos con nombres--
    // cargar pdf a s3
    // validar check para cambiar el pdf--
    // sendEstimateEmail

    //

    //this.download3(1);
    console.log("este debe pasar este lado ps");

    // if( this.estimateCurrent.status === 0){
    this.sendEmail();
    console.log("Ingreso para armar el correo");
    /* }else{
        this.sendEmailFinal();
        console.log('Solo para enviar el correo');
      }*/

    console.log("este debe pasar este lado ps sssssssssssssss");
  }

  sendEmailFinal() {
    let subjectTemp; //= 'Montacargas Master Cotización '+ this.estimateCurrent.estimate_consecutive;
    if (this.subject.trim().length > 0) {
      console.log("importante el subject:" + this.subject);
      subjectTemp = this.subject;
    } else {
      subjectTemp =
        "Montacargas Master Cotización " +
        this.estimateCurrent.estimate_consecutive;
    }
    // concatenar los correos y nos con ","
    let emailsName = "";
    for (let i = 0; i < this.emailsSend.length; i++) {
      if (i !== 0) {
        emailsName = emailsName + "|";
      }
      emailsName =
        emailsName +
        this.emailsSend[i].email +
        "|" +
        this.emailsSend[i].contact;
    }

    console.log(
      "vamos a salir de dudas " + this.masterEmail + "--" + this.masterName
    );
    if (this.masterEmail != "" || this.masterName != "") {
      emailsName = this.masterEmail + "|" + this.masterName + "|" + emailsName;
    }

    console.log("------------------");
    console.log("estos son los correos");
    console.log(emailsName);
    console.log(this.emailsSend.length);
    console.log("---------------------");

    if (this.emailsSend.length > 0) {
      console.log("ingreso a la función YCV");

      this.estimateService
        .sendEstimateEmailAmazon(
          //sendEstimateEmailAmazon
          this.estimateCurrent.elaborate_user_id,
          this.estimateCurrent.customer_id,
          this.estimateCurrent.id,
          emailsName.trim(),
          this.comment,
          subjectTemp
        )
        .then((data) => {
          const resp: any = data;
          console.log("envio");
          console.log(resp);

          if (resp.status == 200) {
            console.log("no error");
            console.log("Entro a cambiar estatus");
            this.estimateService
              .updateEstimateStatus(this.estimateCurrent.id, 1)
              .then((data) => {
                const resp: any = data;
                console.log("envio");
                console.log(resp);
                this.getEstimateFiltersInitial();
                document.getElementById("emailDetailHide").click();
                swal({
                  title: "Correo enviado",
                  type: "success",
                });
                this.masterEmail = "";
                this.masterName = "";

                this.checkHideCode = false;
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error");
            swal({
              title: "Error al enviar el correo",
              text: "Por favor verificar que los archivos adjuntos no tengan caracteres especiales en los nombres",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (this.masterEmail != "" || this.masterName != "") {
      console.log("Ingreso donde se debe validar");
      this.estimateService
        .sendEstimateEmailAmazon(
          //sendEstimateEmailAmazon
          this.estimateCurrent.elaborate_user_id,
          this.estimateCurrent.customer_id,
          this.estimateCurrent.id,
          emailsName.trim(),
          this.comment,
          subjectTemp
        )
        .then((data) => {
          const resp: any = data;
          console.log("envio");
          console.log(resp);

          if (resp.status == 200) {
            console.log("no error");
            console.log("Entro a cambiar estatus");
            this.estimateService
              .updateEstimateStatus(this.estimateCurrent.id, 1)
              .then((data) => {
                const resp: any = data;
                console.log("envio");
                console.log(resp);
                this.getEstimateFiltersInitial();
                document.getElementById("emailDetailHide").click();
                swal({
                  title: "Correo enviado",
                  type: "success",
                });
                this.masterEmail = "";
                this.masterName = "";

                this.checkHideCode = false;
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log("error");
            swal({
              title: "Error al enviar el correo",
              text: "Por favor verificar que los archivos adjuntos no tengan caracteres especiales en los nombres",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          swal({
            text: "Debe ingresar por lo menos un correo electrónico valido",
            type: "error",
          });
        });
    } else {
      swal({
        text: "Debe ingresar por lo menos un correo electrónico valido",
        type: "error",
      });
    }
    //este es el codigo para enviar el correo
  }

  loadPdfSendEmail(ind: number) {
    // this.pp();
    console.log(this.creationDate + " descargando pdf");

    let months = new Array(
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    );
    let days = new Array(
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    );
    let currentDate = new Date(this.creationDate.replace("-", "/"));
    let currentDateFormat =
      days[currentDate.getDay()] +
      ", " +
      currentDate.getDate() +
      " de " +
      months[currentDate.getMonth()] +
      " de " +
      currentDate.getFullYear();
    var body_table = [];

    let imageurl =
      "data:image/png;base64,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";
    const doc = new jsPDF("p", "px", "a4");

    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;

    console.log("este es el ancho" + width);
    console.log("este es el alto" + height);

    doc.autoTable({
      startY: 7,
      columnStyles: {
        2: { cellWidth: 50, fontSize: 8, fillColor: null },
        1: { cellWidth: 260, fontSize: 8, halign: "left", fillColor: null },
        0: { cellWidth: 90, fontSize: 8, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { left: 15 },
      body: [[currentDateFormat, "", "1 de 1"]],
    });

    doc.text("Cotización", 230, 55, "center");
    doc.addImage(imageurl, "PNG", 15, 60, 120, 42);
    //doc.text('Cotizacción', 230, doc.image.previous.finalY, 'center');

    doc.autoTable({
      startY: 60,
      columnStyles: {
        2: { cellWidth: 105, fontSize: 9, fillColor: null },
        1: { cellWidth: 102, fontSize: 9, halign: "left", fillColor: null },
        0: { cellWidth: 88, fontSize: 9, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 60, right: 15, bottom: 0, left: 135 },
      body: [
        [
          "MONTACARGAS MASTER Nit. 900.204.935-2              Medellín - Colombia     ",
          "PBX. (57-4) 444 6055               CLL 10 B sur # 51 42",
          "",
        ],
      ],
    });

    doc.autoTable({
      startY: 85,
      columnStyles: {
        0: { cellWidth: 180, fontSize: 9, fillColor: null },
        1: {
          fontSize: 12,
          halign: "center",
          fillColor: null,
          textColor: [255, 0, 0],
        },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 60, right: 15, bottom: 0, left: 135 },
      body: [["Creado Por: " + this.user, "No. " + this.consecutive]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["CLIENTE"]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 230, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 185 },
      },
      margin: { left: 15 },
      body: [
        [
          "Nit: " + this.documentCustomer + " " + this.nameCustomer,
          "Contacto: " + this.contact,
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 100, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 100 },
        2: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 214 },
      },
      margin: { left: 15 },
      body: [
        [
          "Telefono: " + this.cellphone,
          "Ciudad: " + "Medellín",
          "Maquina: " + "CHEVROLEJTL CHR3566987893 123456543345",
        ],
      ],
    });
    //Vamos en este punto

    //**********************************************************     */

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["MANO DE OBRA Y SERVICIOS"]],
    });

    if (this.checkHideCode == false) {
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 55 },
          2: { halign: "center", fontSize: 9, cellWidth: 185 },
          3: { halign: "center", fontSize: 9, cellWidth: 27 },
          4: { halign: "center", fontSize: 9, cellWidth: 40 },
          5: { halign: "center", fontSize: 9, cellWidth: 39 },
          6: { halign: "center", fontSize: 9, cellWidth: 42 },
          7: { halign: "center", fontSize: 9, cellWidth: 42 },
          8: { halign: "center", fontSize: 9, cellWidth: 42 },
        },
        margin: { left: 15 },
        body: [
          [
            "ITEM",
            "CÓDIGO",
            "DESCRIPCIÓN",
            "CANT.",
            "VLR. UNIT.",
            "TOTAL",
            "IVA",
            "TOTAL IVA",
            "ENTREGA",
          ],
        ],
      });
    } else {
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 190 },
          2: { halign: "center", fontSize: 9, cellWidth: 27 },
          3: { halign: "center", fontSize: 9, cellWidth: 63 },
          4: { halign: "center", fontSize: 9, cellWidth: 63 },
          5: { halign: "center", fontSize: 9, cellWidth: 46 },
        },
        margin: { left: 15 },
        body: [
          ["ITEM", "DESCRIPCIÓN", "CANT.", "VLR. UNIT.", "TOTAL", "ENTREGA"],
        ],
      });
    }
    console.log("Info importante");
    console.log(this.rowsItemsWorkforce);
    if (this.rowsItemsWorkforce.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /*doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme:'grid',
      styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
      columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
      margin: { left: 15},
      body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
    });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].code,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            this.rowsItemsWorkforce[i].hour_value_decimal,
            this.rowsItemsWorkforce[i].subtotal_decimal,
            this.rowsItemsWorkforce[i].iva,
            this.rowsItemsWorkforce[i].total_iva,
            this.rowsItemsWorkforce[i].delivery,
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 205 },
              2: { halign: "center", fontSize: 8, cellWidth: 27 },
              3: { halign: "center", fontSize: 8, cellWidth: 15 },
              4: { halign: "center", fontSize: 8, cellWidth: 15 },
              5: { halign: "center", fontSize: 8, cellWidth: 47 },
              6: { halign: "center", fontSize: 8, cellWidth: 47 },
              7: { halign: "center", fontSize: 8, cellWidth: 47 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /* doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme:'grid',
      styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
      columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
      margin: { left: 15},
      body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
    });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            this.rowsItemsWorkforce[i].hour_value_decimal,
            this.rowsItemsWorkforce[i].subtotal_decimal,
            this.rowsItemsWorkforce[i].iva,
            this.rowsItemsWorkforce[i].total_iva,
            this.rowsItemsWorkforce[i].delivery,
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "center", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
              6: { halign: "center", fontSize: 9, cellWidth: 46 },
              7: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    if (this.rowsItemsparts.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
    startY: doc.autoTable.previous.finalY,
    theme:'grid',
    styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
    columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
    margin: { left: 15},
    body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
  });*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].code,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            this.rowsItemsparts[i].price_decimal,
            this.rowsItemsparts[i].subtotal_decimal,
            this.rowsItemsparts[i].delivery,
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 55 },
              2: { halign: "left", fontSize: 8, cellWidth: 185 },
              3: { halign: "center", fontSize: 8, cellWidth: 27 },
              4: { halign: "center", fontSize: 8, cellWidth: 40 },
              5: { halign: "center", fontSize: 8, cellWidth: 39 },
              6: { halign: "center", fontSize: 8, cellWidth: 42 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
    startY: doc.autoTable.previous.finalY,
    theme:'grid',
    styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
    columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
    margin: { left: 15},
    body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
  });*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            "$" + this.rowsItemsparts[i].price_decimal,
            "$" + this.rowsItemsparts[i].subtotal_decimal,
            this.rowsItemsparts[i].delivery,
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "left", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: null,
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
      },
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [
        [
          "Validez Oferta: 5 días",
          "Forma Pago: 30 días",
          "Garantía: 90 días",
          "Subtotal Repuestos:",
          "1.500.000",
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
      },
      margin: { left: 15 },
      body: [
        [
          {
            content: "HNYUCW-00128",
            colSpan: 3,
            rowSpan: 3,
            styles: { halign: "left" },
          },
          "Subtotal Mano de Obra",
          "0",
        ],
        ["Total", "89000"],
        [
          {
            content: "NOTA: VALORES ANTES DE IVA",
            colSpan: 2,
            styles: { halign: "left" },
          },
        ],
      ],
    });

    console.log(this.filesImage.length + " oleole");
    //doc.addPage();
    /*for (let i = 0; i < this.filesImage.length; i++) {
      console.log('este es el valor de los i');
      console.log(i);
      console.log(this.filesImage[i]);
      let a = this.filesImage[i].content;
      let b = 1+i;
      let j = 400;
      let k= j*b;


    }*/

    /*  var img = new Image;
    img.crossOrigin = "";
    img.src = this.filesImage[0].url;
    var exts = this.filesImage[0].ext;
    img.onload = function () {
      doc.addImage(img, exts,  15, 200, 150,150);
      doc.save('FirstPdf.pdf');
    }
*/

    var height = doc.autoTable.previous.finalY;
    if (doc.autoTable.previous.finalY + 150 > 631) {
      doc.addPage();
      height = 100;
    }

    var imagesLong = this.filesImage.length;

    if (imagesLong > 0) {
      // Si hay imagenes

      var src;
      var img;
      var exts;
      var img2;
      var src2;
      var exts2;
      var img3;
      var src3;
      var exts3;
      var img4;
      var src4;
      var exts4;

      if (this.filesImage[0]) {
        img = new Image();
        this.extImageOne = this.filesImage[0].ext;
        src = this.filesImage[0].url;
      }
      if (this.filesImage[1]) {
        img2 = new Image();
        src2 = this.filesImage[1].url;
        this.extImageTwo = this.filesImage[1].ext;
      }

      if (this.filesImage[2]) {
        img3 = new Image();
        src3 = this.filesImage[2].url;
        this.extImageThree = this.filesImage[2].ext;
      }
      if (this.filesImage[3]) {
        img4 = new Image();
        src4 = this.filesImage[3].url;
        this.extImageFour = this.filesImage[3].ext;
      }

      var extOne = this.extImageOne;
      var extTwo = this.extImageTwo;
      var extThree = this.extImageThree;
      var extFour = this.extImageFour;

      img.onload = function () {
        height = height + 10;
        doc.addImage(img, extOne, 15, height, 150, 150);
        //doc.save('FirstPdf.pdf');
        //doc.addPage();
        height = height + 150;

        if (height + 150 > 631) {
          doc.addPage();
          height = 20;
        } else {
          height = height + 151;
        }
        if (2 <= imagesLong) {
          img2.onload = function () {
            doc.addImage(img2, this.extImageTwo, 15, height, 150, 150);

            //  doc.save('FirstPdf.pdf');
            // doc.addPage();
            if (height + 150 > 631) {
              doc.addPage();
              height = 20;
            } else {
              height = height + 151;
            }
            if (3 <= imagesLong) {
              img3.onload = function () {
                doc.addImage(img3, this.extImageThree, 15, height, 150, 150);

                //  doc.save('FirstPdf.pdf');
                //  doc.addPage();
                if (height + 150 > 631) {
                  doc.addPage();
                  height = 100;
                } else {
                  height = height + 151;
                }
                if (4 <= imagesLong) {
                  img4.onload = function () {
                    doc.addImage(img4, "png", 15, this.extImageFour, 150, 150);
                    // doc.save('FirstPdf.pdf');
                    // this.blobGlobal = doc.output('blob');
                    // this.upload();
                  };
                  img4.crossOrigin = "";
                  img4.src = src4;
                  var exts = exts4;
                  //----------------
                  //----------------
                }
              };

              img3.crossOrigin = "";
              img3.src = src3;
              var exts = exts3;
              //----------------
            } else {
              // doc.save('FirstPdf.pdf');
              this.blobGlobal = doc.output("blob");
              this.upload();
            }
          };
          img2.crossOrigin = "";
          img2.src = src2;
          var exts = exts2;

          //-------
        } else {
          // doc.save('FirstPdf.pdf');
          // this.blobGlobal = doc.output('blob');
          // this.upload();
        }
      };
      img.crossOrigin = "";
      img.src = src;
    }

    /*   if(this.filesImage[0]){
          console.log('0');
          console.log(this.filesImage[0].ext);
          doc.addImage(this.filesImage[0].content,this.filesImage[0].ext,  15, 200, 150,150);
        }


        if(this.filesImage[1]){
          console.log('1');
          console.log(this.filesImage[1].ext);
          doc.addImage(this.filesImage[1].content, this.filesImage[1].ext,  15, 350, 100, 100);
        }*/

    /*
        if(this.filesImage[2]){
          console.log('2');
          console.log(this.filesImage[2].ext);
          doc.addImage(this.filesImage[2].content, this.filesImage[2].ext,  15, 500, 222, 100);
        }*/

    if (ind == 0) {
      //   doc.save('FirstPdf.pdf');
      this.blobGlobal = doc.output("blob");
      this.upload();
    } else {
      this.blobGlobal = doc.output("blob");
      this.upload();
    }
  }

  download4(ind: number) {
    // this.pp();

    let months = new Array(
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    );
    let days = new Array(
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    );
    let currentDate = new Date(this.creationDate.replace("-", "/"));
    let currentDateFormat =
      days[currentDate.getDay()] +
      ", " +
      currentDate.getDate() +
      " de " +
      months[currentDate.getMonth()] +
      " de " +
      currentDate.getFullYear();
    // let currentDate = new Date();
    // let currentDateFormat = days[currentDate.getDay()] + ", " + currentDate.getDate() + " de " + months[currentDate.getMonth()] + " de " + currentDate.getFullYear();
    var body_table = [];

    let imageurl =
      "data:image/png;base64,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";
    const doc = new jsPDF("p", "px", "a4");

    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;

    console.log("este es el ancho" + width);
    console.log("este es el alto" + height);

    doc.autoTable({
      startY: 7,
      columnStyles: {
        2: { cellWidth: 50, fontSize: 8, fillColor: null },
        1: { cellWidth: 260, fontSize: 8, halign: "left", fillColor: null },
        0: { cellWidth: 90, fontSize: 8, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { left: 15 },
      body: [[currentDateFormat, "", "1 de 1"]],
    });

    doc.text("Cotización", 230, 55, "center");
    doc.addImage(imageurl, "PNG", 15, 60, 120, 42);
    //doc.text('Cotizacción', 230, doc.image.previous.finalY, 'center');

    doc.autoTable({
      startY: 60,
      columnStyles: {
        2: { cellWidth: 105, fontSize: 9, fillColor: null },
        1: { cellWidth: 102, fontSize: 9, halign: "left", fillColor: null },
        0: { cellWidth: 88, fontSize: 9, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 60, right: 15, bottom: 0, left: 135 },
      body: [
        [
          "MONTACARGAS MASTER Nit. 900.204.935-2              Medellín - Colombia     ",
          "PBX. (57-4) 444 6055               CLL 10 B sur # 51 42",
          "",
        ],
      ],
    });

    doc.autoTable({
      startY: 85,
      columnStyles: {
        0: { cellWidth: 180, fontSize: 9, fillColor: null },
        1: {
          fontSize: 12,
          halign: "center",
          fillColor: null,
          textColor: [255, 0, 0],
        },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 60, right: 15, bottom: 0, left: 135 },
      body: [["Creado Por: " + this.user, "No. " + this.consecutive]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["CLIENTE"]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 230, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 185 },
      },
      margin: { left: 15 },
      body: [
        [
          "Nit: " + this.documentCustomer + " " + this.nameCustomer,
          "Contacto: " + this.contact,
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 100, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 100 },
        2: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 214 },
      },
      margin: { left: 15 },
      body: [
        [
          "Telefono: " + this.cellphone,
          "Ciudad: " + "Medellín",
          "Maquina: " + "CHEVROLEJTL CHR3566987893 123456543345",
        ],
      ],
    });
    //Vamos en este punto

    //**********************************************************     */

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["MANO DE OBRA Y SERVICIOS"]],
    });

    if (this.checkHideCode == false) {
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 55 },
          2: { halign: "center", fontSize: 9, cellWidth: 185 },
          3: { halign: "center", fontSize: 9, cellWidth: 27 },
          4: { halign: "center", fontSize: 9, cellWidth: 40 },
          5: { halign: "center", fontSize: 9, cellWidth: 39 },
          6: { halign: "center", fontSize: 9, cellWidth: 42 },
          7: { halign: "center", fontSize: 9, cellWidth: 42 },
          8: { halign: "center", fontSize: 9, cellWidth: 42 },
        },
        margin: { left: 15 },
        body: [
          [
            "ITEM",
            "CÓDIGO",
            "DESCRIPCIÓN",
            "CANT.",
            "VLR. UNIT.",
            "TOTAL",
            "IVA",
            "TOTAL IVA",
            "ENTREGA",
          ],
        ],
      });
    } else {
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 190 },
          2: { halign: "center", fontSize: 9, cellWidth: 27 },
          3: { halign: "center", fontSize: 9, cellWidth: 63 },
          4: { halign: "center", fontSize: 9, cellWidth: 63 },
          5: { halign: "center", fontSize: 9, cellWidth: 46 },
          6: { halign: "center", fontSize: 9, cellWidth: 46 },
          7: { halign: "center", fontSize: 9, cellWidth: 46 },
        },
        margin: { left: 15 },
        body: [
          [
            "ITEM",
            "DESCRIPCIÓN",
            "CANT.",
            "VLR. UNIT.",
            "TOTAL",
            "IVA",
            "TOTAL IVA",
            "ENTREGA",
          ],
        ],
      });
    }

    if (this.rowsItemsWorkforce.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /*doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme:'grid',
        styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
        columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
        margin: { left: 15},
        body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
      });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].code,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            this.rowsItemsWorkforce[i].hour_value_decimal,
            this.rowsItemsWorkforce[i].subtotal_decimal,
            this.rowsItemsWorkforce[i].iva,
            this.rowsItemsWorkforce[i].total_iva,
            this.rowsItemsWorkforce[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 205 },
              2: { halign: "center", fontSize: 8, cellWidth: 27 },
              3: { halign: "center", fontSize: 8, cellWidth: 15 },
              4: { halign: "center", fontSize: 8, cellWidth: 15 },
              5: { halign: "center", fontSize: 8, cellWidth: 47 },
              6: { halign: "center", fontSize: 8, cellWidth: 47 },
              7: { halign: "center", fontSize: 8, cellWidth: 47 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /* doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme:'grid',
        styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
        columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
        margin: { left: 15},
        body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
      });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            this.rowsItemsWorkforce[i].hour_value_decimal,
            this.rowsItemsWorkforce[i].subtotal_price,
            this.rowsItemsWorkforce[i].delivery + "",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "center", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    if (this.rowsItemsparts.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme:'grid',
      styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
      columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
      margin: { left: 15},
      body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
    });*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].code,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            "$" + this.rowsItemsparts[i].price_decimal,
            "$" + this.rowsItemsparts[i].subtotal_decimal,
            this.rowsItemsparts[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 55 },
              2: { halign: "left", fontSize: 8, cellWidth: 185 },
              3: { halign: "center", fontSize: 8, cellWidth: 27 },
              4: { halign: "center", fontSize: 8, cellWidth: 40 },
              5: { halign: "center", fontSize: 8, cellWidth: 39 },
              6: { halign: "center", fontSize: 8, cellWidth: 42 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme:'grid',
      styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
      columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
      margin: { left: 15},
      body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
    });*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            "$" + this.rowsItemsparts[i].price_decimal,
            "$" + this.rowsItemsparts[i].subtotal_decimal,
            this.rowsItemsparts[i].delivery,
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "left", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: null,
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
      },
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [
        [
          "Validez Oferta: 5 días",
          "Forma Pago: 30 días",
          "Garantía: 90 días",
          "Subtotal Repuestos:",
          "1.500.000",
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
      },
      margin: { left: 15 },
      body: [
        [
          {
            content: "HNYUCW-00128",
            colSpan: 3,
            rowSpan: 3,
            styles: { halign: "left" },
          },
          "Subtotal Mano de Obra",
          "0",
        ],
        ["Total", "89000"],
        [
          {
            content: "NOTA: VALORES ANTES DE IVA",
            colSpan: 2,
            styles: { halign: "left" },
          },
        ],
      ],
    });

    console.log(this.filesImage.length + " oleole");
    //doc.addPage();
    /*for (let i = 0; i < this.filesImage.length; i++) {
        console.log('este es el valor de los i');
        console.log(i);
        console.log(this.filesImage[i]);
        let a = this.filesImage[i].content;
        let b = 1+i;
        let j = 400;
        let k= j*b;


      }*/

    /*  var img = new Image;
      img.crossOrigin = "";
      img.src = this.filesImage[0].url;
      var exts = this.filesImage[0].ext;
      img.onload = function () {
        doc.addImage(img, exts,  15, 200, 150,150);
        doc.save('FirstPdf.pdf');
      }
  */

    var height = doc.autoTable.previous.finalY;
    if (doc.autoTable.previous.finalY + 150 > 631) {
      doc.addPage();
      height = 100;
    }

    for (let i = 0; i < this.filesImage.length; i++) {
      doc.addImage(
        this.filesImage[i].content,
        this.filesImage[i].ext,
        15,
        height,
        120,
        42
      );
      height = height + 12;
    }
    var imagesLong = this.filesImage.length;
    doc.addImage(imageurl, "PNG", 15, height, 120, 42);
    if (imagesLong > 0) {
      // Si hay imagenes

      var src;
      var img;
      var exts;
      var img2;
      var src2;
      var exts2;
      var img3;
      var src3;
      var exts3;
      var img4;
      var src4;
      var exts4;

      if (this.filesImage[0]) {
        img = new Image();
        this.extImageOne = this.filesImage[0].ext;
        src = this.filesImage[0].url;
      }
      if (this.filesImage[1]) {
        img2 = new Image();
        src2 = this.filesImage[1].url;
        this.extImageTwo = this.filesImage[1].ext;
      }

      if (this.filesImage[2]) {
        img3 = new Image();
        src3 = this.filesImage[2].url;
        this.extImageThree = this.filesImage[2].ext;
      }
      if (this.filesImage[3]) {
        img4 = new Image();
        src4 = this.filesImage[3].url;
        this.extImageFour = this.filesImage[3].ext;
      }

      var extOne = this.extImageOne;
      var extTwo = this.extImageTwo;
      var extThree = this.extImageThree;
      var extFour = this.extImageFour;

      img.onload = function () {
        height = height + 10;
        doc.addImage(img, extOne, 15, height, 150, 150);
        //doc.save('FirstPdf.pdf');
        //doc.addPage();
        height = height + 150;

        if (height + 150 > 631) {
          doc.addPage();
          height = 20;
        } else {
          height = height + 151;
        }
        if (2 <= imagesLong) {
          img2.onload = function () {
            doc.addImage(img2, this.extImageTwo, 15, height, 150, 150);

            //  doc.save('FirstPdf.pdf');
            // doc.addPage();
            if (height + 150 > 631) {
              doc.addPage();
              height = 20;
            } else {
              height = height + 151;
            }
            if (3 <= imagesLong) {
              img3.onload = function () {
                doc.addImage(img3, this.extImageThree, 15, height, 150, 150);

                //  doc.save('FirstPdf.pdf');
                //  doc.addPage();
                if (height + 150 > 631) {
                  doc.addPage();
                  height = 100;
                } else {
                  height = height + 151;
                }
                if (4 <= imagesLong) {
                  img4.onload = function () {
                    doc.addImage(img4, "png", 15, this.extImageFour, 150, 150);

                    // test
                    this.blobGlobal = doc.output("blob");
                    this.uploadFile();

                    doc.save("FirstPdf.pdf");
                  };
                  img4.crossOrigin = "";
                  img4.src = src4;
                  var exts = exts4;
                  //----------------
                  //----------------
                }
              };

              img3.crossOrigin = "";
              img3.src = src3;
              var exts = exts3;
              //----------------
            } else {
              // test
              this.blobGlobal = doc.output("blob");
              this.uploadFile();

              doc.save("FirstPdf.pdf");
            }
          };
          img2.crossOrigin = "";
          img2.src = src2;
          var exts = exts2;

          //-------
        } else {
          // test
          this.blobGlobal = doc.output("blob");
          //this.uploadFile();

          doc.save("FirstPdf.pdf");
        }
      };
      img.crossOrigin = "";
      img.src = src;
      this.upload();
    }

    /*   if(this.filesImage[0]){
            console.log('0');
            console.log(this.filesImage[0].ext);
            doc.addImage(this.filesImage[0].content,this.filesImage[0].ext,  15, 200, 150,150);
          }


          if(this.filesImage[1]){
            console.log('1');
            console.log(this.filesImage[1].ext);
            doc.addImage(this.filesImage[1].content, this.filesImage[1].ext,  15, 350, 100, 100);
          }*/

    /*
          if(this.filesImage[2]){
            console.log('2');
            console.log(this.filesImage[2].ext);
            doc.addImage(this.filesImage[2].content, this.filesImage[2].ext,  15, 500, 222, 100);
          }*/

    if (ind == 0) {
      doc.save("FirstPdf.pdf");
      this.blobGlobal = doc.output("blob");
      this.upload();
    } else {
      this.blobGlobal = doc.output("blob");
      this.upload();
    }
  }

  downloadSend(ind: number) {
    // this.pp();

    let months = new Array(
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    );
    let days = new Array(
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    );
    let currentDate = new Date(this.creationDate.replace("-", "/"));
    let currentDateFormat =
      days[currentDate.getDay()] +
      ", " +
      currentDate.getDate() +
      " de " +
      months[currentDate.getMonth()] +
      " de " +
      currentDate.getFullYear();
    //let currentDate = new Date();
    //let currentDateFormat = days[currentDate.getDay()] + ", " + currentDate.getDate() + " de " + months[currentDate.getMonth()] + " de " + currentDate.getFullYear();
    var body_table = [];

    let imageurl =
      "data:image/png;base64,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";
    const doc = new jsPDF("p", "px", "a4");

    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;

    console.log("este es el ancho" + width);
    console.log("este es el alto" + height);

    // if(this.imgBase) {
    doc.addImage(this.imgBase, "JPG", 15, 60, 100, 0);
    // }

    doc.autoTable({
      startY: 7,
      columnStyles: {
        2: { cellWidth: 50, fontSize: 8, fillColor: null },
        1: { cellWidth: 260, fontSize: 8, halign: "left", fillColor: null },
        0: { cellWidth: 90, fontSize: 8, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { left: 15 },
      body: [[currentDateFormat, "", "1 de 1"]],
    });

    doc.text("Cotización", 230, 380, "center");
    doc.addImage(imageurl, "PNG", 15, 390, 555, 42);
    //doc.text('Cotizacción', 230, doc.image.previous.finalY, 'center');

    doc.autoTable({
      startY: 390,
      columnStyles: {
        2: { cellWidth: 105, fontSize: 9, fillColor: null },
        1: { cellWidth: 102, fontSize: 9, halign: "left", fillColor: null },
        0: { cellWidth: 88, fontSize: 9, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 390, right: 15, bottom: 0, left: 135 },
      body: [
        [
          "MONTACARGAS MASTER Nit. 900.204.935-2              Medellín - Colombia     ",
          "PBX. (57-4) 444 6055               CLL 10 B sur # 51 42",
          "",
        ],
      ],
    });

    doc.autoTable({
      startY: 85,
      columnStyles: {
        0: { cellWidth: 180, fontSize: 9, fillColor: null },
        1: {
          fontSize: 12,
          halign: "center",
          fillColor: null,
          textColor: [255, 0, 0],
        },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 60, right: 15, bottom: 0, left: 135 },
      body: [["Creado Por: " + this.user, "No. " + this.consecutive]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["CLIENTE"]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 230, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 185 },
      },
      margin: { left: 15 },
      body: [
        [
          "Nit: " + this.documentCustomer + " " + this.nameCustomer,
          "Contacto: " + this.contact,
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 100, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 100 },
        2: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 214 },
      },
      margin: { left: 15 },
      body: [
        [
          "Telefono: " + this.cellphone,
          "Ciudad: " + this.cityEstimate,
          "Maquina: " + this.forkliftText,
        ],
      ],
    });
    //Vamos en este punto

    //**********************************************************     */

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["MANO DE OBRA Y SERVICIOS"]],
    });

    if (this.checkHideCode == false) {
      console.log("Ingreso codigo" + this.checkHideCode);
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 55 },
          2: { halign: "center", fontSize: 9, cellWidth: 175 },
          3: { halign: "center", fontSize: 9, cellWidth: 27 },
          4: { halign: "center", fontSize: 9, cellWidth: 45 },
          5: { halign: "center", fontSize: 9, cellWidth: 45 },
          6: { halign: "center", fontSize: 9, cellWidth: 42 },
        },
        margin: { left: 15 },
        body: [
          [
            "ITEM",
            "CÓDIGO",
            "DESCRIPCIÓN",
            "CANT.",
            "VLR. UNIT.",
            "TOTAL",
            "ENTREGA",
          ],
        ],
      });
    } else {
      console.log("Ingreso para ocultar codigo");
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 190 },
          2: { halign: "center", fontSize: 9, cellWidth: 27 },
          3: { halign: "center", fontSize: 9, cellWidth: 63 },
          4: { halign: "center", fontSize: 9, cellWidth: 63 },
          5: { halign: "center", fontSize: 9, cellWidth: 46 },
        },
        margin: { left: 15 },
        body: [
          ["ITEM", "DESCRIPCIÓN", "CANT.", "VLR. UNIT.", "TOTAL", "ENTREGA"],
        ],
      });
    }
    // importante cambio
    if (this.rowsItemsWorkforce.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /*doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme:'grid',
      styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
      columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
      margin: { left: 15},
      body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
    });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].code,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            "$" + this.rowsItemsWorkforce[i].hour_value_decimal,
            "$" + this.rowsItemsWorkforce[i].subtotal_decimal,
            this.rowsItemsWorkforce[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 55 },
              2: { halign: "left", fontSize: 8, cellWidth: 175 },
              3: { halign: "center", fontSize: 8, cellWidth: 28 },
              4: { halign: "center", fontSize: 8, cellWidth: 45 },
              5: { halign: "center", fontSize: 8, cellWidth: 45 },
              6: { halign: "center", fontSize: 8, cellWidth: 40 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /* doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme:'grid',
      styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
      columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
      margin: { left: 15},
      body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
    });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            "$" + this.rowsItemsWorkforce[i].hour_value_decimal,
            "$" + this.rowsItemsWorkforce[i].subtotal_decimal,
            this.rowsItemsWorkforce[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "left", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    if (this.rowsItemsparts.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
    startY: doc.autoTable.previous.finalY,
    theme:'grid',
    styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
    columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
    margin: { left: 15},
    body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
  });*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].code,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            "$" + this.rowsItemsparts[i].price_decimal,
            "$" + this.rowsItemsparts[i].subtotal_decimal,
            this.rowsItemsparts[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 55 },
              2: { halign: "left", fontSize: 8, cellWidth: 175 },
              3: { halign: "center", fontSize: 8, cellWidth: 27 },
              4: { halign: "center", fontSize: 8, cellWidth: 45 },
              5: { halign: "center", fontSize: 8, cellWidth: 45 },
              6: { halign: "center", fontSize: 8, cellWidth: 41 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
    startY: doc.autoTable.previous.finalY,
    theme:'grid',
    styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
    columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
    margin: { left: 15},
    body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
  });*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            "$" + this.rowsItemsparts[i].price_decimal,
            "$" + this.rowsItemsparts[i].subtotal_decimal,
            this.rowsItemsparts[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "left", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: null,
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
      },
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [
        [
          "Validez Oferta: " + this.validity + " días",
          "Forma Pago: " + this.payment_method + " días",
          "Garantía: " + this.guarantyEstimate + " días",
          "Subtotal Repuestos:",
          "$" + this.subtotalPartsEstimate,
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
      },
      margin: { left: 15 },
      body: [
        [
          {
            content: this.observationEstimate,
            colSpan: 3,
            rowSpan: 3,
            styles: { halign: "left" },
          },
          "Subtotal Mano de Obra",
          "$" + this.subtotalHoursEstimate,
        ],
        ["Total", "$" + this.totalEstimate],
        [
          {
            content: "NOTA: VALORES ANTES DE IVA",
            colSpan: 2,
            styles: { halign: "left" },
          },
        ],
      ],
    });

    if (this.filesImage.length > 0) {
      console.log("MOSTRAME POR FAVOR LA URL" + this.filesImage[0].url);
      var img4 = new Image();
      img4.crossOrigin = "";
      img4.src = this.filesImage[0].content;
      var exts = this.filesImage[0].ext;

      // img4.onload = function() {
      doc.addImage(
        img4,
        exts,
        15,
        doc.autoTable.previous.finalY + 20,
        150,
        150
      );
      console.log("ingreso por este 4");
    }
    // doc.save('CuatroFirstPdf.pdf');
    // this.blobGlobal = doc.output('blob');
    // };

    this.blobGlobal = doc.output("blob");
    console.log("ingreso a ja");
    this.sendEmailEstimateAmazon();

    //  console.log(this.filesImage.length+' oleole');
    //doc.addPage();
    /*for (let i = 0; i < this.filesImage.length; i++) {
      console.log('este es el valor de los i');
      console.log(i);
      console.log(this.filesImage[i]);
      let a = this.filesImage[i].content;
      let b = 1+i;
      let j = 400;
      let k= j*b;


    }*/

    /*  var img = new Image;
    img.crossOrigin = "";
    img.src = this.filesImage[0].url;
    var exts = this.filesImage[0].ext;
    img.onload = function () {
      doc.addImage(img, exts,  15, 200, 150,150);
      doc.save('FirstPdf.pdf');
    }
*/

    // var height=doc.autoTable.previous.finalY;
    // if(doc.autoTable.previous.finalY+150>631){
    //  doc.addPage();
    //  height=100;
    // }

    /*
var imagesLong= this.filesImage.length;


var src;
var img;
var exts;
var img2;
var src2;
var exts2;
var img3;
var src3;
var exts3;
var img4;
var src4;
var exts4 ;


if(this.filesImage[0]){
   img = new Image;
   this.extImageOne = this.filesImage[0].ext;
   src = this.filesImage[0].url;
}
if(this.filesImage[1]){
   img2 = new Image;
   src2 = this.filesImage[1].url;
   this.extImageTwo = this.filesImage[1].ext;
}

if(this.filesImage[2]){
   img3 = new Image;
   src3 = this.filesImage[2].url;
   this.extImageThree = this.filesImage[2].ext;
}
if(this.filesImage[3]){
   img4 = new Image;
   src4 = this.filesImage[3].url;
   this.extImageFour = this.filesImage[3].ext;
}


var extOne=this.extImageOne;
var extTwo=this.extImageTwo;
var extThree=this.extImageThree;
var extFour=this.extImageFour;

if(imagesLong>0){ // Si hay imagenes




img.onload = function() {


      height=height+10;
      doc.addImage(img, extOne,  15,  height, 150,150);
      //doc.save('FirstPdf.pdf');
      //doc.addPage();


      if(height+150>631){
        doc.addPage();
        height=20;
      }else{
        height=height+151;
      }
      if(2<=imagesLong){
      img2.onload = function() {
        doc.addImage(img2, extTwo,  15,  height, 150,150);

      //  doc.save('FirstPdf.pdf');
       // doc.addPage();
       if(height+150>631){
        doc.addPage();
        height=20;
      }else{
        height=height+151;
      }
       if(3<=imagesLong){
       img3.onload = function() {
        doc.addImage(img3, extThree,  15,  height, 150,150);

      //  doc.save('FirstPdf.pdf');
      //  doc.addPage();
      if(height+150>631){
        doc.addPage();
        height=100;
      }else{
        height=height+151;
      }
      if(4<=imagesLong){
      img4.onload = function() {
        doc.addImage(img4, extFour,  15, height, 150,150);
        console.log('ingreso por este 4');
        doc.save('CuatroFirstPdf.pdf');

    };
    img4.crossOrigin = "";
    img4.src = src4;
    var exts = exts4;
//----------------
//----------------
}

    };

    img3.crossOrigin = "";
    img3.src = src3;
    var exts = exts3;
//----------------
}else{
  doc.save('TresFirstPdf.pdf');

}

    };
    img2.crossOrigin = "";
    img2.src = src2;
    var exts = exts2;

    //-------
  }else{
    doc.save('DosFirstPdf.pdf');
  }
  };
  img.crossOrigin = "";
  img.src = src;

} */

    /*   if(this.filesImage[0]){
          console.log('0');
          console.log(this.filesImage[0].ext);
          doc.addImage(this.filesImage[0].content,this.filesImage[0].ext,  15, 200, 150,150);
        }


        if(this.filesImage[1]){
          console.log('1');
          console.log(this.filesImage[1].ext);
          doc.addImage(this.filesImage[1].content, this.filesImage[1].ext,  15, 350, 100, 100);
        }*/

    /*
        if(this.filesImage[2]){
          console.log('2');
          console.log(this.filesImage[2].ext);
          doc.addImage(this.filesImage[2].content, this.filesImage[2].ext,  15, 500, 222, 100);
        }*/

    /* if(ind==0){
    doc.save('FirstPdf.pdf');

    }else{
      this.blobGlobal = doc.output('blob');
      console.log('ingreso a ja');
      this.ja();
    }*/

    console.log("el ja tiene el metodo para enviar el correo");
  }

  download3(ind: number) {
    // this.pp();

    let months = new Array(
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    );
    let days = new Array(
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    );
    let currentDate = new Date(this.creationDate.replace("-", "/"));
    let currentDateFormat =
      days[currentDate.getDay()] +
      ", " +
      currentDate.getDate() +
      " de " +
      months[currentDate.getMonth()] +
      " de " +
      currentDate.getFullYear();
    var body_table = [];

    let imageurl =
      "data:image/png;base64,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";
    const doc = new jsPDF("p", "px", "a4");

    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;

    console.log("este es el ancho" + width);
    console.log("este es el alto" + height);

    doc.autoTable({
      startY: 7,
      columnStyles: {
        2: { cellWidth: 50, fontSize: 8, fillColor: null },
        1: { cellWidth: 260, fontSize: 8, halign: "left", fillColor: null },
        0: { cellWidth: 90, fontSize: 8, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { left: 15 },
      body: [[currentDateFormat, "", "1 de 1"]],
    });
    // doc.addImage(this.imgBase, "PNG", 15, 0, 300, 50);

    doc.text("Cotización", 266, 90, "center");
    doc.addImage(imageurl, "PNG", 15, 60, 120, 42);

    //doc.text('Cotizacción', 230, doc.image.previous.finalY, 'center');

    doc.autoTable({
      startY: 60,
      columnStyles: {
        2: { cellWidth: 105, fontSize: 9, fillColor: null },
        1: { cellWidth: 102, fontSize: 9, halign: "left", fillColor: null },
        0: { cellWidth: 88, fontSize: 9, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 60, right: 15, bottom: 0, left: 135 },
      body: [
        [
          "MONTACARGAS MASTER Nit. 900.204.935-2              Medellín - Colombia     ",
          "PBX. (57-4) 444 6055               CLL 10 B sur # 51 42",
          "",
        ],
      ],
    });

    doc.autoTable({
      startY: 85,
      columnStyles: {
        0: { cellWidth: 180, fontSize: 9, fillColor: null },
        1: {
          fontSize: 12,
          halign: "center",
          fillColor: null,
          textColor: [255, 0, 0],
        },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 60, right: 15, bottom: 0, left: 135 },
      body: [["Creado Por: " + this.user, "No. " + this.consecutive]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["CLIENTE"]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 230, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 185 },
      },
      margin: { left: 15 },
      body: [
        [
          "Nit: " + this.documentCustomer + " " + this.nameCustomer,
          "Contacto: " + this.contact,
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 100, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 100 },
        2: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 214 },
      },
      margin: { left: 15 },
      body: [
        [
          "Telefono: " + this.cellphone,
          "Ciudad: " + this.cityEstimate,
          "Maquina: " + this.forkliftText,
        ],
      ],
    });
    //Vamos en este punto

    //**********************************************************     */

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["MANO DE OBRA Y SERVICIOS"]],
    });

    if (this.checkHideCode == false) {
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 55 },
          2: { halign: "center", fontSize: 9, cellWidth: 185 },
          3: { halign: "center", fontSize: 9, cellWidth: 27 },
          4: { halign: "center", fontSize: 9, cellWidth: 40 },
          5: { halign: "center", fontSize: 9, cellWidth: 39 },
          6: { halign: "center", fontSize: 9, cellWidth: 42 },
        },
        margin: { left: 15 },
        body: [
          [
            "ITEM",
            "CÓDIGO",
            "DESCRIPCIÓN",
            "CANT.",
            "VLR. UNIT.",
            "TOTAL",
            "ENTREGA",
          ],
        ],
      });
    } else {
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 190 },
          2: { halign: "center", fontSize: 9, cellWidth: 27 },
          3: { halign: "center", fontSize: 9, cellWidth: 63 },
          4: { halign: "center", fontSize: 9, cellWidth: 63 },
          5: { halign: "center", fontSize: 9, cellWidth: 46 },
        },
        margin: { left: 15 },
        body: [
          ["ITEM", "DESCRIPCIÓN", "CANT.", "VLR. UNIT.", "TOTAL", "ENTREGA"],
        ],
      });
    }

    if (this.rowsItemsWorkforce.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /*doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme:'grid',
      styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
      columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
      margin: { left: 15},
      body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
    });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].code,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            "$" + this.rowsItemsWorkforce[i].hour_value_decimal,
            "$" + this.rowsItemsWorkforce[i].subtotal_decimal,
            this.rowsItemsWorkforce[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 55 },
              2: { halign: "left", fontSize: 8, cellWidth: 175 },
              3: { halign: "center", fontSize: 8, cellWidth: 28 },
              4: { halign: "center", fontSize: 8, cellWidth: 45 },
              5: { halign: "center", fontSize: 8, cellWidth: 45 },
              6: { halign: "center", fontSize: 8, cellWidth: 40 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /* doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme:'grid',
      styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
      columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
      margin: { left: 15},
      body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
    });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            "$" + this.rowsItemsWorkforce[i].hour_value_decimal,
            "$" + this.rowsItemsWorkforce[i].subtotal_decimal,
            this.rowsItemsWorkforce[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "center", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    if (this.rowsItemsparts.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
    startY: doc.autoTable.previous.finalY,
    theme:'grid',
    styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
    columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
    margin: { left: 15},
    body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
  });*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].code,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            "$" + this.rowsItemsparts[i].price_decimal,
            "$" + this.rowsItemsparts[i].subtotal_decimal,
            this.rowsItemsparts[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 55 },
              2: { halign: "left", fontSize: 8, cellWidth: 175 },
              3: { halign: "center", fontSize: 8, cellWidth: 27 },
              4: { halign: "center", fontSize: 8, cellWidth: 45 },
              5: { halign: "center", fontSize: 8, cellWidth: 45 },
              6: { halign: "center", fontSize: 8, cellWidth: 41 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
    startY: doc.autoTable.previous.finalY,
    theme:'grid',
    styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
    columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
    margin: { left: 15},
    body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
  });*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            "$" + this.rowsItemsparts[i].price_decimal,
            "$" + this.rowsItemsparts[i].subtotal,
            this.rowsItemsparts[i].delivery + " días",
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "left", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: null,
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
      },
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [
        [
          "Validez Oferta: " + this.validity + " días",
          "Forma Pago: " + this.payment_method + " días",
          "Garantía: " + this.guarantyEstimate + " días",
          "Subtotal Repuestos:",
          "$" + this.subtotalPartsEstimate,
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
        5: { halign: "center", fontSize: 8, cellWidth: 81 },
        6: { halign: "center", fontSize: 8, cellWidth: 81 },
        textColor: [255, 0, 0],
      },
      margin: { left: 15 },
      body: [
        [
          {
            content: this.observationEstimate,
            colSpan: 3,
            rowSpan: 4,
            styles: { halign: "left" },
          },
          "Subtotal Mano de Obra",
          "$" + this.subtotalHoursEstimate,
        ],
        ["Total", "$" + this.totalEstimate],
        ["Iva", "$" + this.iva],
        ["Total + iva", "$" + this.total_iva],
        [
          {
            content:
              "Montacargas Máster es AUTORRETENEDOR EN RENTA según Resolucion N°6541 del 04/09/2019",
            colSpan: 2,
            styles: { halign: "left", textColor: [255, 0, 0] },
          },
        ],
        [
          {
            content:
              "Una vez el cliente suministre los números de parte no se acepta devolución por mala identificación de piezas.",
            colSpan: 2,
            styles: { halign: "left", textColor: [255, 0, 0] },
          },
        ],
      ],
    });

    // if(this.imgBase) {
    // doc.addImage(this.imgBase, "JPG", 15, 350, 100, 0);
    // }

    console.log("info de imagenes");

    console.log(this.filesImage);

    if (this.filesImage.length > 0) {
      console.log(this.estimateCurrent);

      console.log("MOSTRAME POR FAVOR LA URL" + this.filesImage[0].url);
      var img4 = new Image();
      img4.onload = function () {
        doc.addImage(
          img4,
          exts,
          15,
          doc.autoTable.previous.finalY + 20,
          150,
          150
        );
        console.log("ingreso por este 4");
        doc.save("Cotizacion_No_" + estimateConsecutive + ".pdf");
      };
      img4.crossOrigin = "";
      img4.src = this.filesImage[0].url;
      var exts = this.filesImage[0].ext;
      var estimateConsecutive = this.consecutive;
      // console.log('este es el numero: '+ this.estimateCurrent.estimate_consecutive);
    } else {
      doc.save("Cotizacion_No_" + this.consecutive + ".pdf");
    }

    //  console.log(this.filesImage.length+' oleole');
    //doc.addPage();
    /*for (let i = 0; i < this.filesImage.length; i++) {
      console.log('este es el valor de los i');
      console.log(i);
      console.log(this.filesImage[i]);
      let a = this.filesImage[i].content;
      let b = 1+i;
      let j = 400;
      let k= j*b;


    }*/

    /*  var img = new Image;
    img.crossOrigin = "";
    img.src = this.filesImage[0].url;
    var exts = this.filesImage[0].ext;
    img.onload = function () {
      doc.addImage(img, exts,  15, 200, 150,150);
      doc.save('FirstPdf.pdf');
    }
*/

    // var height=doc.autoTable.previous.finalY;
    // if(doc.autoTable.previous.finalY+150>631){
    //  doc.addPage();
    //  height=100;
    // }

    /*
var imagesLong= this.filesImage.length;


var src;
var img;
var exts;
var img2;
var src2;
var exts2;
var img3;
var src3;
var exts3;
var img4;
var src4;
var exts4 ;


if(this.filesImage[0]){
   img = new Image;
   this.extImageOne = this.filesImage[0].ext;
   src = this.filesImage[0].url;
}
if(this.filesImage[1]){
   img2 = new Image;
   src2 = this.filesImage[1].url;
   this.extImageTwo = this.filesImage[1].ext;
}

if(this.filesImage[2]){
   img3 = new Image;
   src3 = this.filesImage[2].url;
   this.extImageThree = this.filesImage[2].ext;
}
if(this.filesImage[3]){
   img4 = new Image;
   src4 = this.filesImage[3].url;
   this.extImageFour = this.filesImage[3].ext;
}


var extOne=this.extImageOne;
var extTwo=this.extImageTwo;
var extThree=this.extImageThree;
var extFour=this.extImageFour;

if(imagesLong>0){ // Si hay imagenes




img.onload = function() {


      height=height+10;
      doc.addImage(img, extOne,  15,  height, 150,150);
      //doc.save('FirstPdf.pdf');
      //doc.addPage();


      if(height+150>631){s
        doc.addPage();
        height=20;
      }else{
        height=height+151;
      }
      if(2<=imagesLong){
      img2.onload = function() {
        doc.addImage(img2, extTwo,  15,  height, 150,150);

      //  doc.save('FirstPdf.pdf');
       // doc.addPage();
       if(height+150>631){
        doc.addPage();
        height=20;
      }else{
        height=height+151;
      }
       if(3<=imagesLong){
       img3.onload = function() {
        doc.addImage(img3, extThree,  15,  height, 150,150);

      //  doc.save('FirstPdf.pdf');
      //  doc.addPage();
      if(height+150>631){
        doc.addPage();
        height=100;
      }else{
        height=height+151;
      }
      if(4<=imagesLong){
      img4.onload = function() {
        doc.addImage(img4, extFour,  15, height, 150,150);
        console.log('ingreso por este 4');
        doc.save('CuatroFirstPdf.pdf');

    };
    img4.crossOrigin = "";
    img4.src = src4;
    var exts = exts4;
//----------------
//----------------
}

    };

    img3.crossOrigin = "";
    img3.src = src3;
    var exts = exts3;
//----------------
}else{
  doc.save('TresFirstPdf.pdf');

}

    };
    img2.crossOrigin = "";
    img2.src = src2;
    var exts = exts2;

    //-------
  }else{
    doc.save('DosFirstPdf.pdf');
  }
  };
  img.crossOrigin = "";
  img.src = src;

} */

    /*   if(this.filesImage[0]){
          console.log('0');
          console.log(this.filesImage[0].ext);
          doc.addImage(this.filesImage[0].content,this.filesImage[0].ext,  15, 200, 150,150);
        }


        if(this.filesImage[1]){
          console.log('1');
          console.log(this.filesImage[1].ext);
          doc.addImage(this.filesImage[1].content, this.filesImage[1].ext,  15, 350, 100, 100);
        }*/

    /*
        if(this.filesImage[2]){
          console.log('2');
          console.log(this.filesImage[2].ext);
          doc.addImage(this.filesImage[2].content, this.filesImage[2].ext,  15, 500, 222, 100);
        }*/

    /* if(ind==0){
    doc.save('FirstPdf.pdf');

    }else{
      this.blobGlobal = doc.output('blob');
      console.log('ingreso a ja');
      this.ja();
    }*/

    console.log("el ja tiene el metodo para enviar el correo");
    swal.close();
  }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          resolve(reader.result);
        },
        false
      );
      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    });
  }

  createPdf() {
    var doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("With content", 14, 22);
    doc.setFontSize(11);
    doc.setTextColor(100);

    // jsPDF 1.4+ uses getWidth, <1.4 uses .width
    var pageSize = doc.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    //  var text = doc.splitTextToSize(faker.lorem.sentence(45), pageWidth - 35, {});

    var body_table = [];
    let i = 0;
    body_table = [
      i + 1,
      this.rowsItemsparts[i].code,
      this.rowsItemsparts[i].description,
      this.rowsItemsparts[i].quantity,
      this.rowsItemsparts[i].price_decimal,
      this.rowsItemsparts[i].subtotal_decimal,
      this.rowsItemsparts[i].delivery,
    ];

    doc.autoTable({
      startY: 23,
      theme: "grid",
      styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
      columnStyles: {
        0: { halign: "center", fontSize: 8, cellWidth: 23 },
        1: { halign: "center", fontSize: 8, cellWidth: 55 },
        2: { halign: "left", fontSize: 8, cellWidth: 185 },
        3: { halign: "center", fontSize: 8, cellWidth: 27 },
        4: { halign: "center", fontSize: 8, cellWidth: 40 },
        5: { halign: "center", fontSize: 8, cellWidth: 39 },
        6: { halign: "center", fontSize: 8, cellWidth: 42 },
      },
      margin: { left: 15 },
      body: [body_table],
    });

    doc.text("i", 14, doc.autoTable.previous.finalY + 10);

    doc.save("table.pdf");
  }

  // ***********************************

  downloadSend2(ind: number) {
    console.log("downloadSend");

    // this.pp();

    let months = new Array(
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    );
    let days = new Array(
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    );
    let currentDate = new Date(this.creationDate.replace("-", "/"));
    let currentDateFormat =
      days[currentDate.getDay()] +
      ", " +
      currentDate.getDate() +
      " de " +
      months[currentDate.getMonth()] +
      " de " +
      currentDate.getFullYear();
    //let currentDate = new Date();
    //let currentDateFormat = days[currentDate.getDay()] + ", " + currentDate.getDate() + " de " + months[currentDate.getMonth()] + " de " + currentDate.getFullYear();
    var body_table = [];

    let imageurl =
      "data:image/png;base64,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";
    const doc = new jsPDF("p", "px", "a4");

    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;

    console.log("este es el ancho" + width);
    console.log("este es el alto" + height);

    doc.autoTable({
      startY: 7,
      columnStyles: {
        2: { cellWidth: 50, fontSize: 8, fillColor: null },
        1: { cellWidth: 260, fontSize: 8, halign: "left", fillColor: null },
        0: { cellWidth: 90, fontSize: 8, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { left: 15 },
      body: [[currentDateFormat, "", "1 de 1"]],
    });

    doc.text("Cotización", 230, 55, "center");
    // doc.addImage(imageurl, "PNG", 15, 60, 120, 42);
    //doc.text('Cotizacción', 230, doc.image.previous.finalY, 'center');

    doc.autoTable({
      startY: 60,
      columnStyles: {
        2: { cellWidth: 105, fontSize: 9, fillColor: null },
        1: { cellWidth: 102, fontSize: 9, halign: "left", fillColor: null },
        0: { cellWidth: 88, fontSize: 9, halign: "left", fillColor: null },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 60, right: 15, bottom: 0, left: 135 },
      body: [
        [
          "MONTACARGAS MASTER Nit. 900.204.935-2              Medellín - Colombia     ",
          "PBX. (57-4) 444 6055               CLL 10 B sur # 51 42",
          "",
        ],
      ],
    });

    doc.autoTable({
      startY: 85,
      columnStyles: {
        0: { cellWidth: 180, fontSize: 9, fillColor: null },
        1: {
          fontSize: 12,
          halign: "center",
          fillColor: null,
          textColor: [255, 0, 0],
        },
      },
      alternateRowStyles: { fontSize: 9 },
      margin: { top: 60, right: 15, bottom: 0, left: 135 },
      body: [["Creado Por: " + this.user, "No. " + this.consecutive]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["CLIENTE"]],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 230, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 185 },
      },
      margin: { left: 15 },
      body: [
        [
          "Nit: " + this.documentCustomer + " " + this.nameCustomer,
          "Contacto: " + this.contact,
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { cellWidth: 100, fontSize: 9, fillColor: null },
        1: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 100 },
        2: { fontSize: 9, halign: "left", fillColor: null, cellWidth: 214 },
      },
      margin: { left: 15 },
      body: [
        [
          "Telefono: " + this.cellphone,
          "Ciudad: " + "Medellín",
          "Maquina: " + "CHEVROLEJTL CHR3566987893 123456543345",
        ],
      ],
    });
    //Vamos en este punto

    //**********************************************************     */

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: [215, 215, 215],
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [["MANO DE OBRA Y SERVICIOS"]],
    });

    if (this.checkHideCode == false) {
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 55 },
          2: { halign: "center", fontSize: 9, cellWidth: 185 },
          3: { halign: "center", fontSize: 9, cellWidth: 27 },
          4: { halign: "center", fontSize: 9, cellWidth: 40 },
          5: { halign: "center", fontSize: 9, cellWidth: 39 },
          6: { halign: "center", fontSize: 9, cellWidth: 42 },
          7: { halign: "center", fontSize: 9, cellWidth: 42 },
          8: { halign: "center", fontSize: 9, cellWidth: 42 },
        },
        margin: { left: 15 },
        body: [
          [
            "ITEM",
            "CÓDIGO",
            "DESCRIPCIÓN",
            "CANT.",
            "VLR. UNIT.",
            "TOTAL",
            "IVA",
            "TOTAL IVA",
            "ENTREGA",
          ],
        ],
      });
    } else {
      doc.autoTable({
        startY: doc.autoTable.previous.finalY,
        theme: "grid",
        styles: {
          fillColor: [215, 215, 215],
          lineColor: [4, 1, 0],
          lineWidth: 0.2,
        },
        columnStyles: {
          0: { halign: "center", fontSize: 9, cellWidth: 23 },
          1: { halign: "center", fontSize: 9, cellWidth: 190 },
          2: { halign: "center", fontSize: 9, cellWidth: 27 },
          3: { halign: "center", fontSize: 9, cellWidth: 63 },
          4: { halign: "center", fontSize: 9, cellWidth: 63 },
          5: { halign: "center", fontSize: 9, cellWidth: 46 },
          6: { halign: "center", fontSize: 9, cellWidth: 46 },
          7: { halign: "center", fontSize: 9, cellWidth: 46 },
        },
        margin: { left: 15 },
        body: [
          [
            "ITEM",
            "DESCRIPCIÓN",
            "CANT.",
            "VLR. UNIT.",
            "TOTAL",
            "IVA",
            "TOTAL IVA",
            "ENTREGA",
          ],
        ],
      });
    }

    if (this.rowsItemsWorkforce.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /*doc.autoTable({
    startY: doc.autoTable.previous.finalY,
    theme:'grid',
    styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
    columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
    margin: { left: 15},
    body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
  });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].code,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            this.rowsItemsWorkforce[i].hour_value_decimal,
            this.rowsItemsWorkforce[i].subtotal_decimal,
            this.rowsItemsWorkforce[i].delivery,
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 55 },
              2: { halign: "center", fontSize: 8, cellWidth: 185 },
              3: { halign: "center", fontSize: 8, cellWidth: 28 },
              4: { halign: "center", fontSize: 8, cellWidth: 40 },
              5: { halign: "center", fontSize: 8, cellWidth: 40 },
              6: { halign: "center", fontSize: 8, cellWidth: 40 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["MANO DE OBRA"]],
        });

        /* doc.autoTable({
    startY: doc.autoTable.previous.finalY,
    theme:'grid',
    styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
    columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
    margin: { left: 15},
    body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
  });*/

        for (let i = 0; i < this.rowsItemsWorkforce.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsWorkforce[i].service,
            this.rowsItemsWorkforce[i].quantity,
            this.rowsItemsWorkforce[i].hour_value_decimal,
            this.rowsItemsWorkforce[i].subtotal_decimal,
            this.rowsItemsWorkforce[i].delivery,
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "center", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    if (this.rowsItemsparts.length > 0) {
      if (this.checkHideCode == false) {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
  startY: doc.autoTable.previous.finalY,
  theme:'grid',
  styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
  columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
  margin: { left: 15},
  body: [['ITEM','CÓDIGO','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
});*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].code,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            this.rowsItemsparts[i].price_decimal,
            this.rowsItemsparts[i].subtotal_decimal,
            this.rowsItemsparts[i].delivery,
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 8, cellWidth: 23 },
              1: { halign: "left", fontSize: 8, cellWidth: 55 },
              2: { halign: "left", fontSize: 8, cellWidth: 185 },
              3: { halign: "center", fontSize: 8, cellWidth: 27 },
              4: { halign: "center", fontSize: 8, cellWidth: 40 },
              5: { halign: "center", fontSize: 8, cellWidth: 39 },
              6: { halign: "center", fontSize: 8, cellWidth: 42 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      } else {
        doc.autoTable({
          startY: doc.autoTable.previous.finalY,
          theme: "grid",
          styles: {
            fillColor: [215, 215, 215],
            valign: "top",
            lineColor: [4, 1, 0],
            lineWidth: 0.2,
          },
          columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
          margin: { top: 60, right: 15, bottom: 0, left: 15 },
          body: [["REPUESTOS"]],
        });

        /* doc.autoTable({
  startY: doc.autoTable.previous.finalY,
  theme:'grid',
  styles: {fillColor: [215,215,215],lineColor:[4,1,0],lineWidth:0.2},
  columnStyles: {0: {halign: 'center', fontSize:9, cellWidth:23}, 1: {halign: 'center', fontSize:9, cellWidth:55},2: {halign: 'center', fontSize:9, cellWidth:185},3: {halign: 'center', fontSize:9, cellWidth:27},4: {halign: 'center', fontSize:9, cellWidth:40}, 5: {halign: 'center', fontSize:9, cellWidth:39}, 6: {halign: 'center', fontSize:9, cellWidth:42}  },
  margin: { left: 15},
  body: [['ITEM','DESCRIPCIÓN','CANT.','VLR. UNIT.','TOTAL','ENTREGA']]
});*/

        for (let i = 0; i < this.rowsItemsparts.length; i++) {
          body_table = [
            i + 1,
            this.rowsItemsparts[i].description,
            this.rowsItemsparts[i].quantity,
            this.rowsItemsparts[i].price_decimal,
            this.rowsItemsparts[i].subtotal,
            this.rowsItemsparts[i].delivery,
          ];

          doc.autoTable({
            startY: doc.autoTable.previous.finalY,
            theme: "grid",
            styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
            columnStyles: {
              0: { halign: "center", fontSize: 9, cellWidth: 23 },
              1: { halign: "left", fontSize: 9, cellWidth: 190 },
              2: { halign: "center", fontSize: 9, cellWidth: 27 },
              3: { halign: "center", fontSize: 9, cellWidth: 63 },
              4: { halign: "center", fontSize: 9, cellWidth: 63 },
              5: { halign: "center", fontSize: 9, cellWidth: 46 },
            },
            margin: { left: 15 },
            body: [body_table],
          });
          // y=y+15;
        }
      }
    }

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: {
        fillColor: null,
        valign: "top",
        lineColor: [4, 1, 0],
        lineWidth: 0.2,
      },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
      },
      margin: { top: 60, right: 15, bottom: 0, left: 15 },
      body: [
        [
          "Validez Oferta: 5 días",
          "Forma Pago: 30 días",
          "Garantía: 90 días",
          "Subtotal Repuestos:",
          "1.500.000",
        ],
      ],
    });

    doc.autoTable({
      startY: doc.autoTable.previous.finalY,
      theme: "grid",
      styles: { fillColor: null, lineColor: [4, 1, 0], lineWidth: 0.2 },
      columnStyles: {
        0: { halign: "left", fontSize: 8, cellWidth: 85 },
        1: { halign: "left", fontSize: 8, cellWidth: 86 },
        2: { halign: "left", fontSize: 8, cellWidth: 81 },
        3: { halign: "left", fontSize: 8, cellWidth: 80 },
        4: { halign: "center", fontSize: 8, cellWidth: 81 },
      },
      margin: { left: 15 },
      body: [
        [
          {
            content: "HNYUCW-00128",
            colSpan: 3,
            rowSpan: 3,
            styles: { halign: "left" },
          },
          "Subtotal Mano de Obra",
          "0",
        ],
        ["Total", "89000"],
        [
          {
            content: "NOTA: VALORES ANTES DE IVA",
            colSpan: 2,
            styles: { halign: "left" },
          },
        ],
      ],
    });

    if (this.filesImage.length > 0) {
      console.log("MOSTRAME POR FAVOR LA URL" + this.filesImage[0].url);
      var img4 = new Image();
      img4.crossOrigin = "";
      img4.src = this.filesImage[0].content;
      var exts = this.filesImage[0].ext;

      // img4.onload = function() {
      doc.addImage(
        img4,
        exts,
        15,
        doc.autoTable.previous.finalY + 20,
        150,
        150
      );
      console.log("ingreso por este 4");
    }
    // doc.save('CuatroFirstPdf.pdf');
    // this.blobGlobal = doc.output('blob');
    // };

    this.blobGlobal = doc.output("blob");
    console.log("ingreso a ja");
    this.sendEmailEstimateAmazon();

    //  console.log(this.filesImage.length+' oleole');
    //doc.addPage();
    /*for (let i = 0; i < this.filesImage.length; i++) {
    console.log('este es el valor de los i');
    console.log(i);
    console.log(this.filesImage[i]);
    let a = this.filesImage[i].content;
    let b = 1+i;
    let j = 400;
    let k= j*b;


  }*/

    /*  var img = new Image;
  img.crossOrigin = "";
  img.src = this.filesImage[0].url;
  var exts = this.filesImage[0].ext;
  img.onload = function () {
    doc.addImage(img, exts,  15, 200, 150,150);
    doc.save('FirstPdf.pdf');
  }
*/

    // var height=doc.autoTable.previous.finalY;
    // if(doc.autoTable.previous.finalY+150>631){
    //  doc.addPage();
    //  height=100;
    // }

    /*
var imagesLong= this.filesImage.length;


var src;
var img;
var exts;
var img2;
var src2;
var exts2;
var img3;
var src3;
var exts3;
var img4;
var src4;
var exts4 ;


if(this.filesImage[0]){
 img = new Image;
 this.extImageOne = this.filesImage[0].ext;
 src = this.filesImage[0].url;
}
if(this.filesImage[1]){
 img2 = new Image;
 src2 = this.filesImage[1].url;
 this.extImageTwo = this.filesImage[1].ext;
}

if(this.filesImage[2]){
 img3 = new Image;
 src3 = this.filesImage[2].url;
 this.extImageThree = this.filesImage[2].ext;
}
if(this.filesImage[3]){
 img4 = new Image;
 src4 = this.filesImage[3].url;
 this.extImageFour = this.filesImage[3].ext;
}


var extOne=this.extImageOne;
var extTwo=this.extImageTwo;
var extThree=this.extImageThree;
var extFour=this.extImageFour;

if(imagesLong>0){ // Si hay imagenes




img.onload = function() {


    height=height+10;
    doc.addImage(img, extOne,  15,  height, 150,150);
    //doc.save('FirstPdf.pdf');
    //doc.addPage();


    if(height+150>631){
      doc.addPage();
      height=20;
    }else{
      height=height+151;
    }
    if(2<=imagesLong){
    img2.onload = function() {
      doc.addImage(img2, extTwo,  15,  height, 150,150);

    //  doc.save('FirstPdf.pdf');
     // doc.addPage();
     if(height+150>631){
      doc.addPage();
      height=20;
    }else{
      height=height+151;
    }
     if(3<=imagesLong){
     img3.onload = function() {
      doc.addImage(img3, extThree,  15,  height, 150,150);

    //  doc.save('FirstPdf.pdf');
    //  doc.addPage();
    if(height+150>631){
      doc.addPage();
      height=100;
    }else{
      height=height+151;
    }
    if(4<=imagesLong){
    img4.onload = function() {
      doc.addImage(img4, extFour,  15, height, 150,150);
      console.log('ingreso por este 4');
      doc.save('CuatroFirstPdf.pdf');

  };
  img4.crossOrigin = "";
  img4.src = src4;
  var exts = exts4;
//----------------
//----------------
}

  };

  img3.crossOrigin = "";
  img3.src = src3;
  var exts = exts3;
//----------------
}else{
doc.save('TresFirstPdf.pdf');

}

  };
  img2.crossOrigin = "";
  img2.src = src2;
  var exts = exts2;

  //-------
}else{
  doc.save('DosFirstPdf.pdf');
}
};
img.crossOrigin = "";
img.src = src;

} */

    /*   if(this.filesImage[0]){
        console.log('0');
        console.log(this.filesImage[0].ext);
        doc.addImage(this.filesImage[0].content,this.filesImage[0].ext,  15, 200, 150,150);
      }


      if(this.filesImage[1]){
        console.log('1');
        console.log(this.filesImage[1].ext);
        doc.addImage(this.filesImage[1].content, this.filesImage[1].ext,  15, 350, 100, 100);
      }*/

    /*
      if(this.filesImage[2]){
        console.log('2');
        console.log(this.filesImage[2].ext);
        doc.addImage(this.filesImage[2].content, this.filesImage[2].ext,  15, 500, 222, 100);
      }*/

    /* if(ind==0){
  doc.save('FirstPdf.pdf');

  }else{
    this.blobGlobal = doc.output('blob');
    console.log('ingreso a ja');
    this.ja();
  }*/

    console.log("el ja tiene el metodo para enviar el correo");
  }

  // *******************************************
  async pp(id: number) {
    await this.getFilesImage(id);

    /* this.getBase64ImageFromUrl('https://masterforklift.s3.amazonaws.com/estimate_files/simpsons_PNG95.png')
    .then(result =>{
    //  console.log(result);
    //this.download(254);
      this.imageGlobal=result;
    })
    .catch(err => console.error(err));*/
  }

  getImgFromUrl(logo_url, callback) {
    var img = new Image();
    img.src = logo_url;
    img.onload = function () {
      callback(img);
    };
  }

  generatePDF(img) {
    var options = { orientation: "p", unit: "mm" };
    var doc = new jsPDF(options);
    doc.addImage(img, "JPEG", 0, 0, 100, 50);
  }

  opp() {
    var logo_url = "/images/logo.jpg";
    this.getImgFromUrl(logo_url, function (img) {
      this.generatePDF(img);
    });
  }

  getCustomers() {
    this.restService
      .getCustomer()
      .then((data) => {
        const resp: any = data;
        //console.log(data);
        swal.close();
        this.customers = resp.data;
        //console.log("Acaa customers", this.customers);
        // this.rowsClient = resp.data;
        // this.rowStatic =  resp.data;
        // this.rowsTemp = resp.data;
        // console.log( this.rowsClient);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getForklifs() {
    console.log(this.selectedBranchOfficeId);
    if (this.selectedBranchOfficeId != 0) {
      this.forkliftService
        .getForkliftBranchOfficesFull(this.selectedBranchOfficeId)
        .then((data) => {
          const resp: any = data;
          console.log(data);
          swal.close();
          this.forklifts = resp.data;
          // this.rowsClient = resp.data;
          // this.rowStatic =  resp.data;
          // this.rowsTemp = resp.data;
          // console.log( this.rowsClient);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  getBranchOffices() {
    console.log("ingreso");
    if (this.selectedBusinessId != 0) {
      console.log(this.selectedBusinessId);
      this.restService
        .getOffice(this.selectedBusinessId)
        .then((data) => {
          const resp: any = data;
          console.log(data);
          swal.close();
          this.branchOffices = resp.data;
          // this.rowsClient = resp.data;
          // this.rowStatic =  resp.data;
          // this.rowsTemp = resp.data;
          // console.log( this.rowsClient);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  partChange(event: any, item: any) {
    console.log("valor para editar");
    console.log(event.target.value);
    console.log(item);
    console.log(item.id);

    for (let i = 0; i < this.itemsPart.length; i++) {
      if (this.itemsPart[i].id == item.id) {
        console.log(item);
        console.log("lo encontre" + i);

        if (event.target.value != "" && event.target.value != 0) {
          this.itemsPart[i].quantity = event.target.value;
          console.log(this.itemsPart[i]);
        } else {
          swal({
            title: "Error",
            text: "Las cantidades deben ser diferentes a 0",
            type: "error",
          });
        }
      }
    }
  }

  workForceChange(event: any, item: any) {
    console.log("valor para editar");
    console.log(event.target.value);
    console.log(item);
    console.log(item.id);

    for (let i = 0; i < this.itemsWorkforce.length; i++) {
      if (this.itemsWorkforce[i].id == item.id) {
        console.log(item);
        console.log("lo encontre" + i);

        if (event.target.value != "" && event.target.value != 0) {
          this.itemsWorkforce[i].quantity = event.target.value;
          console.log(this.itemsWorkforce[i]);
        } else {
          swal({
            title: "Error",
            text: "Las cantidades deben ser diferentes a 0",
            type: "error",
          });
        }
      }
    }
  }

  workForceChangeActive(event: any, item: any) {
    console.log("valor para editar");
    console.log(event);
    console.log(item);
    console.log(item.id);

    for (let i = 0; i < this.itemsWorkforce.length; i++) {
      if (this.itemsWorkforce[i].id == item.id) {
        console.log(item);
        console.log("lo encontre" + i);
        this.itemsWorkforce[i].active = event.target.checked;
        console.log(this.itemsWorkforce[i]);
      }
    }
  }

  partChangeActive(event: any, item: any) {
    console.log("valor para editar");
    console.log(event);
    console.log(item);
    console.log(item.id);

    for (let i = 0; i < this.itemsPart.length; i++) {
      if (this.itemsPart[i].id == item.id) {
        console.log(item);
        console.log("lo encontre" + i);
        this.itemsPart[i].active = event.target.checked;
        console.log(this.itemsPart[i]);
      }
    }
  }

  onChangeCode(event) {
    console.log(event);
    this.checkHideCode = event.target.checked;
    console.log("este es el evento para chekear eso");
  }

  checkUncheckAllWorkforce(event: any) {
    this.checkAllWorkForce = event.target.checked;
    for (let i = 0; i < this.itemsWorkforce.length; i++) {
      console.log("lo encontre" + i);
      this.itemsWorkforce[i].active = event.target.checked;
    }
  }

  checkUncheckAllPart(event: any) {
    this.checkAllPart = event.target.checked;
    for (let i = 0; i < this.itemsPart.length; i++) {
      console.log("lo encontre" + i);
      this.itemsPart[i].active = event.target.checked;
    }
  }

  getEstimateFiltersUser() {
    if (
      this.considerDate == false &&
      this.selectedBusinessId == 0 &&
      this.selectedBranchOfficeId == 0
    ) {
      swal({
        title: "Importante",
        text: "Debes seleccionar por lo menos un cliente y una sede.",
        type: "error",
      });
    } else {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      let params = "";
      let cont = 0;
      if (this.considerDate) {
        // poner los 0
        var day = (this.fromDate.day < 10 ? "0" : "") + this.fromDate.day;
        // 01, 02, 03, ... 10, 11, 12
        let month = (this.fromDate.month < 10 ? "0" : "") + this.fromDate.month;
        // 1970, 1971, ... 2015, 2016, ...
        var year = this.fromDate.year;

        // until poner los ceros
        var dayUntil =
          (this.untilDate.day < 10 ? "0" : "") + this.untilDate.day;
        // 01, 02, 03, ... 10, 11, 12
        let monthUntil =
          (this.untilDate.month < 10 ? "0" : "") + this.untilDate.month;
        // 1970, 1971, ... 2015, 2016, ...
        var yearUntil = this.untilDate.year;

        var fromD = year + "-" + month + "-" + day;
        var untilD = yearUntil + "-" + monthUntil + "-" + dayUntil;
        //var fromD = this.fromDate.year+'-'+this.fromDate.month+'-'+this.fromDate.day; //31 de diciembre de 2015
        // var untilD = this.untilDate.year+'-'+this.untilDate.month+'-'+this.untilDate.day;
        params =
          "from_date=" +
          fromD +
          " 00:00:00" +
          "&&" +
          "to_date=" +
          untilD +
          " 23:59:59";
        cont++;
      }

      if (this.selectedBusinessId != 0) {
        console.log("imprimir cont");
        console.log(cont);
        if (cont > 0) {
          params = params + "&&customer_id=" + this.selectedBusinessId;
        } else {
          params = params + "customer_id=" + this.selectedBusinessId;
          cont++;
        }
      }

      if (this.part != "") {
        if (cont > 0) {
          params = params + "&&description_query=" + this.part;
        } else {
          params = params + "description_query=" + this.part;
          cont++;
        }
      }

      if (this.codepart != "") {
        if (cont > 0) {
          params = params + "&&codepart_query=" + this.codepart;
        } else {
          params = params + "codepart_query=" + this.codepart;
          cont++;
        }
      }

      if (this.numberEstimate != "") {
        if (cont > 0) {
          params = params + "&&consecutive=" + this.numberEstimate;
        } else {
          params = params + "consecutive=" + this.numberEstimate;
          cont++;
        }
      }

      if (this.selectedForkliftId != 0) {
        if (cont > 0) {
          params = params + "&&forklift_id=" + this.selectedForkliftId;
        } else {
          params = params + "forklift_id=" + this.selectedForkliftId;
          cont++;
        }
      }

      if (this.selectedBranchOfficeId != 0) {
        if (cont > 0) {
          params = params + "&&branch_office_id=" + this.selectedBranchOfficeId;
        } else {
          params = params + "branch_office_id=" + this.selectedBranchOfficeId;
          cont++;
        }
      }

      if (this.listStatus.length > 0) {
        if (cont > 0) {
          params = params + "&&status=" + this.listStatus;
        } else {
          params = params + "status=" + this.listStatus;
          cont++;
        }
      }

      console.log(".---------->" + params);
      this.estimateService
        .showEstimateFilter(params)
        .then((data) => {
          const resp: any = data;
          console.log("info de filter");
          console.log(data);
          // this.customers  = resp.data;
          this.rowsClient = resp.data;
          console.log(resp.data);
          console.log(resp.error);
          swal.close();
          if (resp.error) {
            console.log("entro");
            swal({
              title: "Tiempo de busqueda excedido",
              text: "El rango de tiempo seleccionado para la busqueda es muy amplio, seleccione uno mejor para una consulta mas optima.",
              type: "warning",
            });
          }
          // this.rowStatic =  resp.data;
          // this.rowsTemp = resp.data;
          // console.log( this.rowsClient);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  getEstimateFilters() {
    if (
      this.considerDate == false &&
      this.selectedBusinessId == 0 &&
      this.part == 0 &&
      this.codepart == 0 &&
      this.numberEstimate == 0 &&
      this.selectedForkliftId == 0 &&
      this.selectedUserId == 0 &&
      this.listStatus.length == 0 &&
      this.selectedBranchOfficeId == 0
    ) {
      swal({
        title: "Importante",
        text: "Debes seleccionar por lo menos uno de los filtros o activar casilla para tener en cuenta las fechas",
        type: "error",
      });
    } else {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      let params = "";
      let cont = 0;
      if (this.considerDate) {
        // poner los 0
        var day = (this.fromDate.day < 10 ? "0" : "") + this.fromDate.day;
        // 01, 02, 03, ... 10, 11, 12
        let month = (this.fromDate.month < 10 ? "0" : "") + this.fromDate.month;
        // 1970, 1971, ... 2015, 2016, ...
        var year = this.fromDate.year;

        // until poner los ceros
        var dayUntil =
          (this.untilDate.day < 10 ? "0" : "") + this.untilDate.day;
        // 01, 02, 03, ... 10, 11, 12
        let monthUntil =
          (this.untilDate.month < 10 ? "0" : "") + this.untilDate.month;
        // 1970, 1971, ... 2015, 2016, ...
        var yearUntil = this.untilDate.year;

        var fromD = year + "-" + month + "-" + day;
        var untilD = yearUntil + "-" + monthUntil + "-" + dayUntil;
        //var fromD = this.fromDate.year+'-'+this.fromDate.month+'-'+this.fromDate.day; //31 de diciembre de 2015
        // var untilD = this.untilDate.year+'-'+this.untilDate.month+'-'+this.untilDate.day;
        params =
          "from_date=" +
          fromD +
          " 00:00:00" +
          "&&" +
          "to_date=" +
          untilD +
          " 23:59:59";
        cont++;
      }

      if (this.selectedBusinessId != 0) {
        console.log("imprimir cont");
        console.log(cont);
        if (cont > 0) {
          params = params + "&&customer_id=" + this.selectedBusinessId;
        } else {
          params = params + "customer_id=" + this.selectedBusinessId;
          cont++;
        }
      }

      if (this.part != "") {
        if (cont > 0) {
          params = params + "&&description_query=" + this.part;
        } else {
          params = params + "description_query=" + this.part;
          cont++;
        }
      }

      if (this.codepart != "") {
        if (cont > 0) {
          params = params + "&&codepart_query=" + this.codepart;
        } else {
          params = params + "codepart_query=" + this.codepart;
          cont++;
        }
      }

      if (this.numberEstimate != "") {
        if (cont > 0) {
          params = params + "&&consecutive=" + this.numberEstimate;
        } else {
          params = params + "consecutive=" + this.numberEstimate;
          cont++;
        }
      }

      if (this.selectedForkliftId != 0) {
        if (cont > 0) {
          params = params + "&&forklift_id=" + this.selectedForkliftId;
        } else {
          params = params + "forklift_id=" + this.selectedForkliftId;
          cont++;
        }
      }

      if (this.selectedBranchOfficeId != 0) {
        if (cont > 0) {
          params = params + "&&branch_office_id=" + this.selectedBranchOfficeId;
        } else {
          params = params + "branch_office_id=" + this.selectedBranchOfficeId;
          cont++;
        }
      }

      if (this.selectedUserId != 0) {
        if (cont > 0) {
          params = params + "&&user_id=" + this.selectedUserId;
        } else {
          params = params + "user_id=" + this.selectedUserId;
          cont++;
        }
      }

      if (this.listStatus.length > 0) {
        if (cont > 0) {
          params = params + "&&status=" + this.listStatus;
        } else {
          params = params + "status=" + this.listStatus;
          cont++;
        }
      }

      console.log(".---------->" + params);
      this.estimateService
        .showEstimateFilter(params)
        .then((data) => {
          const resp: any = data;
          console.log("info de filter");
          console.log(data);
          // this.customers  = resp.data;
          this.rowsClient = resp.data;
          console.log(resp.data);
          console.log(resp.error);
          swal.close();
          if (resp.error) {
            console.log("entro");
            swal({
              title: "Tiempo de busqueda excedido",
              text: "El rango de tiempo seleccionado para la busqueda es muy amplio, seleccione uno mejor para una consulta mas optima.",
              type: "warning",
            });
          }
          // this.rowStatic =  resp.data;
          // this.rowsTemp = resp.data;
          // console.log( this.rowsClient);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  getEstimateFiltersInitial() {
    let params = "";
    let cont = 0;

    var day = (this.fromDate.day < 10 ? "0" : "") + this.fromDate.day;
    // 01, 02, 03, ... 10, 11, 12
    let month = (this.fromDate.month < 10 ? "0" : "") + this.fromDate.month;
    // 1970, 1971, ... 2015, 2016, ...
    var year = this.fromDate.year;

    // until poner los ceros
    var dayUntil = (this.untilDate.day < 10 ? "0" : "") + this.untilDate.day;
    // 01, 02, 03, ... 10, 11, 12
    let monthUntil =
      (this.untilDate.month < 10 ? "0" : "") + this.untilDate.month;
    // 1970, 1971, ... 2015, 2016, ...
    var yearUntil = this.untilDate.year;

    var fromD = year + "-" + month + "-" + day;
    var untilD = yearUntil + "-" + monthUntil + "-" + dayUntil;

    //  var fromD = this.fromDate.year+'-'+this.fromDate.month+'-'+this.fromDate.day; //31 de diciembre de 2015
    //  var untilD = this.untilDate.year+'-'+this.untilDate.month+'-'+this.untilDate.day;
    params =
      "from_date=" +
      fromD +
      " 00:00:00" +
      "&&" +
      "to_date=" +
      untilD +
      " 23:59:59";

    console.log(".---------->" + params);
    this.estimateService
      .showEstimateFilter(params)
      .then((data) => {
        const resp: any = data;
        console.log("info de filter");
        console.log(data);
        swal.close();
        // this.customers  = resp.data;
        this.rowsClient = resp.data;
        // this.rowStatic =  resp.data;
        // this.rowsTemp = resp.data;
        // console.log( this.rowsClient);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  ole() {
    console.log(this.modelPorpup);
  }

  getCustomersForklift(idCustomer: number) {
    this.forkliftService
      .getForkliftsCustomer(idCustomer)
      .then((data) => {
        const resp: any = data;
        console.log("forklifts");
        console.log(data);
        swal.close();
        this.rowsClient = resp.data;
        this.rowStatic = resp.data;
        this.rowsTemp = resp.data;
        console.log(this.rowsClient);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getBranchOfficeForklift(idBranch: number) {
    this.forkliftService
      .getForkliftsBranch(idBranch)
      .then((data) => {
        const resp: any = data;
        console.log("forklifts branch");
        console.log(data);
        swal.close();
        this.rowsClient = resp.data;
        this.rowStatic = resp.data;
        this.rowsTemp = resp.data;
        console.log(this.rowsClient);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getCustomerOffice() {
    console.log(this.selectedBusinessId);
    this.getCustomersForklift(this.selectedBusinessId);
    this.restService
      .getCustomerOffice(this.selectedBusinessId)
      .then((data) => {
        const resp: any = data;
        console.log("ole ole");
        console.log(resp);
        this.customerOffices = resp.data_branchoffices;
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getOfficeForklift() {
    this.getBranchOfficeForklift(this.selectedOfficeId);
  }

  onChangeCreate(check: any) {
    this.change = check;
    console.log(check);
  }

  selectStatus(item: any) {
    let position = this.listStatus.indexOf(item.id);
    console.log(position);
    if (position >= 0) {
      this.listStatus.splice(position, 1);
    } else {
      this.listStatus.push(item.id);
    }
    console.log(this.listStatus);
  }

  onChangeUpdate(check: any) {
    this.switchUpdate = check;
    this.enabledUpdated = check;

    console.log(check);
  }

  getUser() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.userService
      .getUsers()
      .then((data) => {
        const resp: any = data;
        if (resp.error) {
          swal({
            title: "Error",
            text: "Ha ocurrido un error",
            type: "error",
          });
        } else {
          console.log(data);
          swal.close();
          this.rowsUser = resp.data;
          //console.log("Ussers", this.rowsUser);
        }
      })
      .catch((error) => {
        swal.close();
        swal({
          title: "Error",
          text: "Ha ocurrido un error",
          type: "error",
        });
        console.log(error);
      });
  }

  updateEstimate(row: any) {
    console.log(row);
    this.router.navigateByUrl("maintenance/estimateCustomerUpdate/" + row.id);
  }

  copyEstimateProcess(row: any, trm: any) {
    console.log(row);
    // this.router.navigateByUrl('master/estimateCustomerCopy/'+row.id);
    this.loadingData();
    this.estimateService
      .copyEstimate(row.id, trm, row.customer.price_margin)
      .then((data) => {
        const resp: any = data;
        console.log(resp);
        if (resp.success === false) {
          swal({
            text: "Esta cotizacion presenta problemas para copiar",
            type: "error",
          });
        } else {
          this.loadingData();
          swal({
            title: "Cotización creada",
            type: "success",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateForklift(forklift: any) {
    console.log(forklift);
    this.router.navigateByUrl("maintenance/forkliftUpdate/" + forklift.id);
  }

  sendBrand() {
    console.log(localStorage.getItem("token"));
    this.submitted = true;
    if (!this.myForm.invalid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      let statusTemp = 0;
      if (this.enabledUpdated === true) {
        statusTemp = 0;
      } else {
        statusTemp = 1;
      }
      this.restService
        .createBrand(
          this.myForm.get("description").value.toUpperCase(),
          statusTemp
        )
        .then((data) => {
          const resp: any = data;
          console.log(resp);
          if (resp.success === false) {
            swal({
              title: "Este equipo ya esta registrado",
              text: "Este equipo no se puede registrar",
              type: "error",
            });
          } else {
            this.myForm.get("description").setValue("");
            /*swal({
      title: 'equipo agregada',
      type: 'success'
     });*/
            //   this.router.navigateByUrl('master/registerBrand');

            document.getElementById("createBrandHide").click();
            this.loadingData();
            swal({
              title: "equipo agregado",
              type: "success",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  sendUpdateBrand() {
    console.log(this.myFormUpdate.get("descriptionUpdate"));
    console.log(localStorage.getItem("token"));
    this.submitted = true;
    if (!this.myFormUpdate.invalid) {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      let statusTemp = 1;
      if (this.enabledUpdated === true) {
        statusTemp = 0;
      } else {
        statusTemp = 1;
      }
      console.log(
        this.myFormUpdate.get("descriptionUpdate").value.toUpperCase() +
          " " +
          statusTemp
      );
      this.restService
        .updateBrand(
          Number(this.currentBrand.id),
          this.myFormUpdate.get("descriptionUpdate").value.toUpperCase(),
          statusTemp
        )
        .then((data) => {
          const resp: any = data;
          console.log(resp);
          if (resp.success === false) {
            swal({
              title: "Esta equipo ya esta actualizado",
              text: "Esta equipo no se puede actualizar",
              type: "error",
            });
          } else {
            // this.router.navigateByUrl('master/registerBrand');
            document.getElementById("updateBrandHide").click();
            this.loadingData();
            swal({
              title: "equipo actualizado",
              type: "success",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  get checkForm() {
    return this.myForm.controls;
  }
  get checkFormUpdate() {
    return this.myFormUpdate.controls;
  }

  copyEstimate(row: any) {
    swal({
      title:
        "Estás seguro que deseas copiar la cotización número " +
        row.estimate_consecutive +
        " ?",
      // text: 'Once deleted, you will not be able to recover this imaginary file!',
      type: "warning",
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Si",
    }).then((willDelete) => {
      if (willDelete.value) {
        let trm;
        trmapi
          .latest()
          .then((data) => {
            console.log(data);
            trm = data.valor;
            this.copyEstimateProcess(row, trm);
          })
          .catch((error) => {
            console.log(error);

            this.estimateService
              .showTrmCurrent()
              .then((data) => {
                const resp: any = data;
                //let trm = resp.data.value;
                console.log("RESP " + JSON.stringify(resp));

                try {
                  trm = resp.data.value;
                } catch (error) {
                  trm = resp.result.value;
                }
                console.log("entro");
                this.copyEstimateProcess(row, trm);
              })
              .catch((error) => {
                console.log(error);
              });
          });
      } else {
        // swal('Fail');
      }
      console.log(willDelete);
    });
  }

  showForklift(forklift: any) {
    console.log(forklift);
    this.router.navigateByUrl("maintenance/forkliftShow/" + forklift.id);
  }

  sendForklift() {
    this.router.navigateByUrl("/maintenance/registerForklift");
  }

  createEstimate() {
    this.router.navigateByUrl("maintenance/estimateCustomer");
  }

  ngOnInit() {
    this.columns.forEach((col: any) => {
      const colWidth = this.columnWidths.find(
        (colWidth) => colWidth.column === col.prop
      );
      if (colWidth) {
        col.width = colWidth.width;
      }
    });
  }

  blockAgents(vadr: any) {
    console.log("----------------");
    console.log(vadr);
  }

  showEstimateLink(row: any) {
    console.log("EL NUEVO VALOR");
    console.log(row);
  }

  clearFilter() {
    console.log(this.fromDate);
  }

  onDateSelectionFrom(date: any) {
    if (this.untilDate) {
      var fromD = new Date(
        this.fromDate.year,
        this.fromDate.month,
        this.fromDate.day
      ); //31 de diciembre de 2015
      var untilD = new Date(
        this.untilDate.year,
        this.untilDate.month,
        this.untilDate.day
      );

      console.log(this.fromDate.day);
      if (fromD > untilD) {
        console.log("es mayor");
        this.untilDate = this.fromDate;
      }
    }
  }

  rejectEstimateFinal() {
    this.estimateService
      .updateEstimateStatus(this.estimateCurrent.id, 5)
      .then((data) => {
        const resp: any = data;
        console.log("envio");
        console.log(resp);
        document.getElementById("hideRejection").click();

        this.getEstimateFiltersInitial();
        swal({
          title: "cotización rechazada",
          type: "success",
        });
      })
      .catch((error) => {
        console.log(error);
        swal.close();
      });
  }

  onDateSelectionUntil(date: any) {
    var fromD = new Date(
      this.fromDate.year,
      this.fromDate.month,
      this.fromDate.day
    ); //31 de diciembre de 2015
    var untilD = new Date(
      this.untilDate.year,
      this.untilDate.month,
      this.untilDate.day
    );
    if (untilD < fromD) {
      console.log("es mayor");
      this.fromDate = this.untilDate;
    }
  }

  get getEmails() {
    return this.detailform.get("emails") as FormArray;
  }

  get getNames() {
    return this.detailform.get("names") as FormArray;
  }

  addEmail() {
    console.log("este es el valor de email: " + this.masterEmail);
    if (this.validateEmail(this.masterEmail)) {
      this.emailSend = {
        email: this.masterEmail,
        contact: this.masterName,
      };
      this.emailsSend.push(this.emailSend);

      this.masterEmail = "";
      this.masterName = "";
    } else {
      swal({
        text: "Debe ingresar un correo electrónico valido",
        type: "error",
      });
    }
  }

  validateEmail(email) {
    var regex =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email) ? true : false;
  }

  storageDetail(formValue: any) {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    const emails = formValue.emails;
    const names = formValue.name;
    const subject = formValue.subject;
    const comment = formValue.comment;
    console.log("info");
    console.log(subject);
    console.log(comment);
    console.log("parte");
    console.log(emails[0].email);
    if (
      emails[0].email != null &&
      emails[0].email != "" &&
      comment != null &&
      comment != "" &&
      subject != null &&
      subject != ""
    ) {
      console.log(emails);
      let array = "";
      emails.forEach((email) => {
        if (email.email != null) {
          array += email.email + "<br><br>";
        }
      });
      console.log(array);

      let arrayNames = "";
      names.forEach((name) => {
        if (name.name != null) {
          array += name.name + "<br><br>";
        }
      });
      console.log("este es el array  de los  names");
      console.log(arrayNames);

      /* this.workservice.storeWorkDetail(this.headerinfo.id,comment,array,subject).then(data=>{
      const resp:any=data;
      console.log(data);
      console.log(resp);
      if (resp.success==1) {
        this.generalAlert('Proceso exitoso','Se ha guardado el detalle correctamente','success');
       //  this.getWorkDetails();

        document.getElementById('storageDetailHide').click();emailDetailHide
      } else {
        this.generalAlert('No se puede guardar','Ha ocurrido un error en la ejecucion','error');
      }

    }).catch(error=>{
      console.log(error);
      this.generalAlert('No se puede guardar','Ha ocurrido un error en la ejecucion','error')
    });*/
      this.resetCreateForm();
    } else {
      this.generalAlert(
        "No se puede guardar",
        "Debe Completar todos los campos obligatorios",
        "error"
      );
    }
  }

  resetCreateForm() {
    this.detailform.reset();
    for (let index = this.indice; index > 0; index--) {
      const control = <FormArray>this.detailform.controls["emails"];
      control.removeAt(index);
      this.indice--;
    }
  }

  deleteEmail(index: number) {
    /* const control =<FormArray>this.detailform.controls['emails'];
      control.removeAt(index);
      this.indice--;*/
    this.emailsSend.splice(index);
  }

  generalAlert(title: string, message: string, type: any) {
    swal({
      title: title,
      text: message,
      type: type,
    });
  }

  getFilesImage(ind) {
    console.log("INGRESO A LAS IMAGENES  KKKK");
    this.estimateService
      .getEstimateDetailFilesImages(Number(this.estimateId))
      .then((data) => {
        const resp: any = data;
        this.filesEstimateImage = resp.data;
        console.log("esta es la respuesta de la imagen");
        console.log(resp);

        if (resp.success) {
          this.filesImage = [];
          // for (let i = 0; i < this.filesEstimateImage.length; i++){
          console.log("ingreso a la conversión");
          console.log(this.filesEstimateImage[0].url);

          this.getBase64ImageFromUrl(this.filesEstimateImage[0].url)
            .then((result) => {
              //  console.log(result);
              //this.download(254);
              console.log(result);

              var ext = this.filesEstimateImage[0].name
                .toString()
                .split(".")
                .pop();
              var url = this.filesEstimateImage[0].url;
              console.log("extensiones");
              console.log(ext);
              console.log("ingreso a llenar result");
              this.fileImage = {
                content: result,
                ext: ext,
                url: url,
              };

              // revisar la i
              this.filesImage.push(this.fileImage);

              // if(i== this.filesEstimateImage.length-1){
              console.log("debes pasar por aqui seguridad");

              console.log("este es el indice" + ind);
              if (ind == 0) {
                console.log("ingreso a la descarga");
                this.download3(ind);
              } else {
                console.log("ingreso al envio del correo");
                //this.download3(0);
                this.downloadSend(ind); // Este es el problema
              }

              // Descargar PDF 0
              // Cargar PDF a S3 y enviar 1;

              // }
            })
            .catch((err) => console.error(err));

          // }

          // images.push();
        } else {
          console.log("esto es muy impotante");
          console.log(ind);
          if (ind == 0) {
            console.log("ingreso a la descarg6a");
            this.download3(ind);
          } else {
            console.log("ingreso al envio del corre6o");
            this.downloadSend(ind); //Este es el problema
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  finalApproval() {
    this.itemsFinalApproval = [];
    for (let i = 0; i < this.itemsPart.length; i++) {
      console.log("lo encontre" + i);
      if (this.itemsPart[i].active) {
        this.itemsFinalApproval.push(this.itemsPart[i]);
      }
    }
    for (let i = 0; i < this.itemsWorkforce.length; i++) {
      console.log("lo encontre" + i);
      if (this.itemsWorkforce[i].active) {
        this.itemsFinalApproval.push(this.itemsWorkforce[i]);
      }
    }

    let valuesApproval = "";

    for (let i = 0; i < this.itemsFinalApproval.length; i++) {
      valuesApproval =
        valuesApproval +
        this.itemsFinalApproval[i].id +
        "@" +
        this.itemsFinalApproval[i].quantity +
        "@";
    }

    console.log("items aprobados de cotizacion " + this.estimateCurrent);
    console.log(this.itemsFinalApproval);
    console.log(valuesApproval);

    if (valuesApproval != "") {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      this.estimateService
        .approveEstimateDetails(valuesApproval)
        .then((data) => {
          const resp: any = data;
          console.log("envio autorización");
          console.log(resp);

          //---------------------------
          this.estimateService
            .updateEstimateStatus(this.estimateCurrent.id, 2)
            .then((data) => {
              const resp: any = data;
              console.log("envio");
              console.log(resp);
              document.getElementById("hideCheckItem").click();

              this.getEstimateFiltersInitial();
              swal({
                title: "cotización aprobada",
                type: "success",
              });
            })
            .catch((error) => {
              console.log(error);
              swal.close();
            });
          // ----------------------------
        })
        .catch((error) => {
          console.log(error);
          swal.close();
        });
    } else {
      swal({
        title: "Se presentó un problema",
        text: "Favor selecionar al menos una opcion.",
        type: "error",
      });
    }
  }

  rejectQuote() {}

  ///// Espacio para funciones de prueba

  getDateOnly(dateString: string | undefined): string {
    if (dateString) {
      return dateString.split(" ")[0]; // Ejemplo de uso de split, asegúrate de manejar correctamente dateString
    } else {
      return ""; // Manejo de caso donde dateString es undefined
    }
  }

  getProgressText(value: number): string {
    if (value === 0) {
      return "Pendiente de aprobacion";
    } else if (value === 30) {
      return "Pedido liberado";
    } else if (value === 45) {
      return "Nos encontramos gestionando su pedido";
    } else if (value === 65) {
      return "Su pedido se encuentra en importación";
    } else if (value === 75) {
      return "Estamos en proceso de despacho.";
    } else if (value === 95) {
      return "Pedido despachado.";
    } else if (value === 100) {
      return "Pedido LLego al cliente.";
    }
    return "Pendiente de aprobacion";
  }
  getProgresscolor(value: number): string {
    if (value === 0 || value == 15) {
      return "warning";
    } else if (value === 30) {
      return "warning";
    } else if (value === 45) {
      return "warning";
    } else if (value === 65) {
      return "succes";
    } else if (value === 75) {
      return "warning";
    } else if (value === 100) {
      return "success";
    }
    return "Pendiente de aprobacion";
  }

  formatDate(isoDate: string): string {
    // Que la cadena sea válida
    if (!isoDate) return "";

    // Dividir la cadena en la fecha y la hora
    const [date, time] = isoDate.split("T");

    // Obtener solo la parte de la hora sin los milisegundos y la 'Z'
    const formattedTime = time.split(".")[0];

    // Devolver la fecha en el formato deseado
    return `${date} `;
  }
  ///// Espacio para funciones de prueba

  logfilterData() {
    console.log(
      "Acaaaa pasando consecutivo de OS",
      this.orderServiceConsecutiveF
    );
  }

  logfilterDataCustomer() {
    console.log(
      "id para buscar Ordenes de cliente",
      this.selectedBusinessId.id
    );
  }

  applyFilters() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    const queryParams = new URLSearchParams();

    if (
      !this.filterCriteria.orderServiceConsecutiveF &&
      !this.filterCriteria.selectedBusinessId &&
      !this.filterCriteria.startDate &&
      !this.filterCriteria.endDate &&
      !this.filterCriteria.orderStatus &&
      !this.filterCriteria.selectedUserId
    ) {
      console.log("Debe seleccionar al menos un criterio de filtrado.");
      alert("Debe seleccionar al menos un criterio de filtrado.");
      this.orderservicesFilters = undefined;
      swal.close();
      return; // Salir de la función si no hay criterios de filtrado
    }

    // Log para ver el estado inicial de filterCriteria
    console.log("Estado inicial de filterCriteria:", this.filterCriteria);

    if (this.filterCriteria.orderServiceConsecutiveF) {
      queryParams.append(
        "orderServiceConsecutive",
        this.filterCriteria.orderServiceConsecutiveF
      );
      console.log(
        "Filtro añadido - orderServiceConsecutive:",
        this.filterCriteria.orderServiceConsecutiveF
      );
    }

    if (this.filterCriteria.selectedBusinessId) {
      queryParams.append("businessId", this.filterCriteria.selectedBusinessId);
      console.log(
        "Filtro añadido - businessId:",
        this.filterCriteria.selectedBusinessId
      );
    }

    if (this.filterCriteria.startDate) {
      queryParams.append("startDate", this.filterCriteria.startDate);
      console.log("Filtro añadido - startDate:", this.filterCriteria.startDate);
    }

    if (this.filterCriteria.endDate) {
      queryParams.append("endDate", this.filterCriteria.endDate);
      console.log("Filtro añadido - endDate:", this.filterCriteria.endDate);
    }
    if (this.filterCriteria.orderStatus) {
      queryParams.append("orderStatus", this.filterCriteria.orderStatus);
      console.log(
        "Filtro añadido - orderStatus:",
        this.filterCriteria.orderStatus
      );
    }

    if (this.filterCriteria.selectedUserId) {
      queryParams.append("selectedUserId", this.filterCriteria.selectedUserId);
      console.log(
        "Filtro añadido - selectedUserId:",
        this.filterCriteria.selectedUserId
      );
    }

    if (this.userAdvisor) {
      if (this.customers && this.customers.length > 0) {
        queryParams.append("customersAdvisor", this.customers.map((c: any) => c.id).join(","));
      } else {
        console.log("No hay clientes asociados al asesor, no se aplicará el filtro de clientes.");
        this.orderservicesFilters = [];
        swal.close();
        return;
      }
      console.log("se salto el return bien.");
    }

    const queryString = queryParams.toString();

    // Log para ver la cadena de consulta resultante
    console.log("Cadena de consulta (queryString):", queryString);

    // Simulación de la llamada al servicio, con log de los resultados
    console.log("Llamada al servicio con queryString:", queryString);

    this.orderservice
      .getFilteredOrderservice(queryString)
      .then((data) => {
        const resp: any = data;
        this.orderservicesFilters = Array.isArray(resp.data) ? resp.data : [];
        console.log(
          "Data recibida de órdenes Filtradas:",
          this.orderservicesFilters
        );

        // Inicializa el estado de los productos pendientes para cada orden
        this.checkPendingProductFilter = {};

        if (this.orderservicesFilters.length > 0 && !this.userCustomer && !this.userAdvisor) {
          this.orderservices.forEach((orderService: any) => {
            let hasPendingProducts = false;
            orderService.orders.forEach((order: any) => {
              if (order.import_order_details) {
                hasPendingProducts = order.import_order_details.some(
                  (detail: any) =>
                    detail.product_arrived === 1 && detail.product_dispatch === 0
                );
              }
            });

            // Almacena el resultado en la propiedad para usar en el HTML
            this.checkPendingProductFilter[
              orderService.orderservice_consecutive
            ] = hasPendingProducts;

            // Imprimir el resultado en consola
            console.log(
              `Condición cumplida para orderservice_consecutive desde filtro ${orderService.orderservice_consecutive}:`,
              hasPendingProducts
            );
          });

          this.checkStockProductFilter = {};

          ////Aca validacion de stock
          this.orderservices.forEach((orderService: any) => {
            let hasstockProducts = false;
            orderService.orders.forEach((order: any) => {
              if (order.import_order_details) {
                hasstockProducts = order.import_order_details.some(
                  (detail: any) =>
                    detail.stock === 1 && detail.product_dispatch === 0
                );
              }
            });

            // Almacena el resultado en la propiedad para usar en el HTML
            this.checkStockProductFilter[orderService.orderservice_consecutive] =
              hasstockProducts;

            // Imprimir el resultado en consola
            console.log(
              `Condición cumplida para orderservice_consecutive con sTOCKKKK ${orderService.orderservice_consecutive}:`,
              hasstockProducts
            );
          });
        }
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getComercials() {
    this.orderservice
      .getComercials()
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.users_comercials = resp.data;
        console.log("Data recibida de comerciales:", this.users_comercials);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  adjustedDate(date: string): string {
    const dateObj = new Date(date);

    // Restar 5 horas a la hora de la fecha proporcionada
    dateObj.setHours(dateObj.getHours() - 5);

    // Formatear la fecha a un string en formato `YYYY-MM-DD HH:mm:ss`
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  hasActiveFilters(): boolean {
    return Object.values(this.filterCriteria).some(value => value !== '');
  }

  openOrder(consecutive: string) {
    const url = `/erp/serviceorderdetail/${consecutive}`;
    window.open(url, '_blank');
  }

  //Comparar fechas https://desarrolloweb.com/articulos/comparar-fechas-javascript.html*/
}



// WEBPACK FOOTER //
// ./src/app/master/master-OS-all/master-OS-all.component.ts